<div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
  <ng-container *ngIf="usaWhatsappOficial; else whatsappOficialDisabled">
  <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4 d-none">
    <div class="d-flex flex-wrap justify-content-between align-items-center">
      <div class="titulo_texto_posicao">
        <div class="titulo_texto">WhatsApp Oficial</div>
        <div class="subtitulo_whatsapp_oficial">Inbox e kanban do atendimento em tempo real.</div>
      </div>

      <div class="d-flex align-items-center mt-2 mt-md-0">
        <span class="badge badge-pill mr-2" [ngClass]="configuracao != null && configuracao.is_active ? 'badge-success' : 'badge-secondary'">
          {{ configuracao != null && configuracao.is_active ? "Configuração ativa" : "Configuração pendente" }}
        </span>

        <span class="badge badge-pill mr-2" [ngClass]="tempoRealConectado ? 'badge-info' : 'badge-warning'">
          {{ tempoRealConectado ? "Tempo real conectado" : "Tempo real reconectando" }}
        </span>

        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="atualizarListas(true)">
          Atualizar
        </button>
      </div>
    </div>
  </div>

  <div class="whatsapp_page_body pt-2 pr-4 pb-4 pl-4">
    <div class="alert alert-warning" *ngIf="!isSellerUazapi() && (configuracao == null || configuracao.phone_number_id == null || configuracao.phone_number_id == '')">
      A integração oficial ainda não está configurada. Finalize os dados em
      <a routerLink="/integracoes">Integrações</a>
      para operar este canal.
    </div>

    <ng-template #whatsappToolbarIcones>
      <div class="whatsapp_seg">
        <button type="button" [class.whatsapp_seg_on]="abaAtiva == 'conversas'" (click)="selecionarAba('conversas')" title="Conversas">
          <i class="fa fa-comments-o"></i>
          <span class="whatsapp_aba_badge" *ngIf="qtdeNaoLidasTotal > 0">{{ qtdeNaoLidasTotal }}</span>
        </button>

        <button *ngIf="isSellerUazapi()" type="button" [class.whatsapp_seg_on]="abaAtiva == 'grupos'" (click)="selecionarAba('grupos')" title="Grupos" aria-label="Grupos">
          <i class="fa fa-users"></i>
          <span class="whatsapp_aba_badge" *ngIf="gruposNaoLidos > 0">{{ gruposNaoLidos }}</span>
        </button>

        <button type="button" [class.whatsapp_seg_on]="abaAtiva == 'kanban'" (click)="selecionarAba('kanban')" title="Kanban">
          <i class="fa fa-columns"></i>
        </button>
      </div>

      <button class="whatsapp_icon_btn" type="button" (click)="abaAtiva == 'grupos' ? gruposPainel?.sincronizar() : atualizarListas(true)" title="Atualizar">
        <i class="fa fa-refresh"></i>
      </button>

      <button *ngIf="abaAtiva != 'grupos'" class="whatsapp_icon_btn whatsapp_icon_btn_novo" type="button" (click)="abrirPopupNovoAtendimento()" title="Novo Atendimento">
        <i class="fa fa-plus"></i>
      </button>

      <button
        *ngIf="isSellerUazapi()"
        class="whatsapp_icon_btn whatsapp_icon_status"
        [ngClass]="getClasseStatusUazapi()"
        type="button"
        (click)="abrirPopupUazapiStatus()"
        [title]="getTextoStatusUazapi()">
        <i class="fa fa-qrcode" *ngIf="statusUazapi == null || !statusUazapi.conectado"></i>
        <span class="uazapi_status_dot" *ngIf="statusUazapi != null && statusUazapi.conectado"></span>
      </button>
    </ng-template>

    <div class="whatsapp_tabs d-flex flex-wrap align-items-center" *ngIf="abaAtiva != 'grupos' && (abaAtiva == 'kanban' || (podeVerPagamentos && iaPagamentosConfigurado) || podeGerenciarTemplatesMensagem)">
      <ng-container *ngIf="abaAtiva == 'kanban'">
        <ng-container *ngTemplateOutlet="whatsappToolbarIcones"></ng-container>
      </ng-container>

      <button
        *ngIf="podeVerPagamentos && iaPagamentosConfigurado"
        class="whatsapp_pagamentos_btn ml-auto mb-2"
        type="button"
        (click)="abrirPopupPagamentos()"
        title="Histórico de pagamentos gerados pela IA">
        <i class="fa fa-credit-card"></i>
        <span>Pagamentos</span>
      </button>

      <button
        *ngIf="podeGerenciarTemplatesMensagem"
        class="whatsapp_pagamentos_btn mb-2 ml-2"
        [class.ml-auto]="!(podeVerPagamentos && iaPagamentosConfigurado)"
        type="button"
        (click)="abrirPopupTemplatesGestao()"
        title="Gerenciar templates de mensagem">
        <i class="fa fa-file-text-o"></i>
        <span>Templates</span>
      </button>
    </div>

    <app-whatsapp-grupos *ngIf="isSellerUazapi()" [hidden]="abaAtiva != 'grupos'" [ativa]="abaAtiva == 'grupos'" [toolbar]="whatsappToolbarIcones" (naoLidos)="gruposNaoLidos = $event"></app-whatsapp-grupos>

    <div *ngIf="abaAtiva == 'conversas'" class="whatsapp_layout">
      <div class="whatsapp_sidebar">
        <div class="whatsapp_sidebar_header">
          <div>
            <div class="whatsapp_sidebar_title">Conversas</div>
            <div class="whatsapp_sidebar_subtitle">{{ inboxFiltrado.length }} atendimento(s)</div>
          </div>

          <div class="whatsapp_sidebar_header_actions">
            <ng-container *ngTemplateOutlet="whatsappToolbarIcones"></ng-container>
          </div>
        </div>

        <div class="whatsapp_sidebar_filter">
          <div class="whatsapp_sidebar_filter_box">
            <i class="fa fa-search"></i>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Buscar por cliente, contato ou telefone"
              [ngModel]="filtroInbox"
              (ngModelChange)="onFiltroInboxChange($event)" />
            <button
              type="button"
              class="whatsapp_sidebar_filter_clear"
              *ngIf="filtroInbox"
              (click)="filtroInbox = ''"
              title="Limpar busca">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="whatsapp_status_chips">
            <button type="button" class="whatsapp_status_chip" [class.whatsapp_status_chip_ativo]="filtroStatus == 'TODAS'" (click)="selecionarFiltroStatus('TODAS')">
              Todas
            </button>
            <button type="button" class="whatsapp_status_chip" [class.whatsapp_status_chip_ativo]="filtroStatus == 'NAO_LIDAS'" (click)="selecionarFiltroStatus('NAO_LIDAS')">
              Não lidas <span class="whatsapp_status_chip_count" *ngIf="qtdeNaoLidasTotal > 0">{{ qtdeNaoLidasTotal }}</span>
            </button>
            <button type="button" class="whatsapp_status_chip" [class.whatsapp_status_chip_ativo]="filtroStatus == 'AGUARDANDO_APROVACAO'" (click)="selecionarFiltroStatus('AGUARDANDO_APROVACAO')">
              <i class="fa fa-hourglass-half"></i> Aprovação <span class="whatsapp_status_chip_count" *ngIf="qtdeAguardandoAprovacaoTotal > 0">{{ qtdeAguardandoAprovacaoTotal }}</span>
            </button>
            <button type="button" class="whatsapp_status_chip" [class.whatsapp_status_chip_ativo]="filtroStatus == 'PRECISA_HUMANO'" (click)="selecionarFiltroStatus('PRECISA_HUMANO')">
              <i class="fa fa-user"></i> Humano <span class="whatsapp_status_chip_count" *ngIf="qtdePrecisaHumanoTotal > 0">{{ qtdePrecisaHumanoTotal }}</span>
            </button>

            <button type="button" class="whatsapp_status_chip whatsapp_etapa_chip" [class.whatsapp_status_chip_ativo]="filtroEtapaId != null || filtroSellerId != null" (click)="alternarPainelEtapa($event)" [title]="getNomeFiltroEtapaAtual()">
              <svg class="whatsapp_etapa_chip_icon" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16"></path><path d="M7 12h10"></path><path d="M10 19h4"></path></svg>
              <svg class="whatsapp_etapa_chip_svg" [class.whatsapp_etapa_chip_svg_aberto]="exibirPainelEtapa" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>
            </button>
          </div>

          <div class="whatsapp_etapa_panel" *ngIf="exibirPainelEtapa" (click)="$event.stopPropagation()">
            <details class="whatsapp_filtro_secao">
              <summary class="whatsapp_etapa_panel_titulo">Etapas <span *ngIf="filtroEtapaId != null" class="whatsapp_filtro_aplicado">Filtrado</span></summary>
              <button type="button" class="whatsapp_etapa_item" [class.whatsapp_etapa_item_selecionado]="filtroEtapaId == null" (click)="selecionarFiltroEtapa(null, $event)">
                <span class="whatsapp_etapa_item_label"><span class="whatsapp_etapa_dot" style="background:#cbd5e1"></span>Todas as etapas</span>
              </button>
              <button type="button" class="whatsapp_etapa_item" *ngFor="let etapa of etapas" [class.whatsapp_etapa_item_selecionado]="filtroEtapaId == etapa.id" (click)="selecionarFiltroEtapa(etapa.id, $event)">
                <span class="whatsapp_etapa_item_label"><span class="whatsapp_etapa_dot" [style.background]="etapa.cor_hex"></span>{{ etapa.nome }}</span>
                <span class="whatsapp_etapa_item_count">{{ getContagemPorEtapa(etapa.id) }}</span>
              </button>
              </details>

            <details class="whatsapp_filtro_secao" *ngIf="podeFiltrarConversasPorVendedor">
              <summary class="whatsapp_etapa_panel_titulo">Vendedores <span *ngIf="filtroSellerId != null" class="whatsapp_filtro_aplicado">Filtrado</span></summary>
              <button type="button" class="whatsapp_etapa_item" [class.whatsapp_etapa_item_selecionado]="filtroSellerId == null" (click)="selecionarFiltroVendedor(null, $event)">
                <span class="whatsapp_etapa_item_label"><span class="whatsapp_etapa_dot whatsapp_vendedor_dot"></span>Todos os vendedores</span>
                <span class="whatsapp_etapa_item_count">{{ getContagemTodosVendedoresFiltro() }}</span>
              </button>
              <button type="button" class="whatsapp_etapa_item" *ngFor="let vendedor of vendedoresFiltroConversas; trackBy: trackByVendedorFiltro" [class.whatsapp_etapa_item_selecionado]="filtroSellerId == vendedor.id" (click)="selecionarFiltroVendedor(vendedor.id, $event)">
                <span class="whatsapp_etapa_item_label"><span class="whatsapp_etapa_dot whatsapp_vendedor_dot"></span>{{ vendedor.nome }}</span>
                <span class="whatsapp_etapa_item_count">{{ vendedor.total }}</span>
              </button>
            </details>
          </div>
        </div>

        <div class="whatsapp_sidebar_list" (scroll)="onScrollConversas($event)">
          <div class="whatsapp_empty_filter" *ngIf="inbox.length > 0 && inboxFiltrado.length == 0">
            Nenhuma conversa encontrada para esta busca.
          </div>

          <button
            type="button"
            class="whatsapp_conversation"
            *ngFor="let atendimento of conversasExibidas"
            [ngClass]="{ 'whatsapp_conversation_active': atendimentoSelecionado != null && atendimento.id == atendimentoSelecionado.id }"
            (click)="selecionarAtendimento(atendimento)">
            <div class="whatsapp_conversation_row">
              <div class="whatsapp_avatar">
                <img *ngIf="atendimento.contato_foto_url" [src]="atendimento.contato_foto_url" alt="" class="whatsapp_avatar_foto">
                <ng-container *ngIf="!atendimento.contato_foto_url">{{ getIniciaisAtendimento(atendimento) }}</ng-container>
              </div>

              <div class="whatsapp_conversation_main">
                <div class="whatsapp_conversation_top">
                  <span class="whatsapp_conversation_name">{{ getNomeExibicaoAtendimento(atendimento) }}</span>
                  <span class="whatsapp_conversation_time">{{ atendimento.dt_ultima_mensagem | date:'dd/MM HH:mm' }}</span>
                </div>

                <div class="whatsapp_conversation_phone">{{ atendimento.telefone }}</div>

                <div class="whatsapp_conversation_preview">{{ getPreviewAtendimentoLimitado(atendimento) }}</div>

                <div class="whatsapp_conversation_badges mt-1">
                  <span class="badge badge-pill whatsapp_stage_badge" [ngStyle]="{ 'background-color': getCorEtapaAtendimento(atendimento), 'color': getCorTextoEtapaAtendimento(atendimento) }">
                    {{ getNomeEtapaAtendimento(atendimento) }} {{ getResumoTempo(atendimento) }}
                  </span>

                  <span class="badge badge-pill whatsapp_responsible_badge" *ngIf="podeVerVendedorResponsavel && getNomeVendedorResponsavel(atendimento) != ''">
                    {{ getNomeVendedorResponsavel(atendimento) }}
                  </span>

                  <span class="badge badge-pill whatsapp_ia_badge_gerando" *ngIf="iaGerandoConversas[atendimento.id]">
                    <fa name="magic"></fa> IA gerando resposta...
                  </span>

                  <span class="badge badge-pill whatsapp_ia_badge_pendente" *ngIf="atendimento.ia_sugestao_pendente && !iaGerandoConversas[atendimento.id]">
                    <fa name="hourglass-half"></fa> IA aguardando aprovação
                  </span>

                  <span class="badge badge-pill whatsapp_ia_badge_auto" *ngIf="!atendimento.ia_sugestao_pendente && !iaGerandoConversas[atendimento.id] && getIaModoEfetivoAtendimento(atendimento) == 'AUTO'">
                    <fa name="magic"></fa> IA Auto
                  </span>

                  <span class="badge badge-pill whatsapp_ia_badge_handoff" *ngIf="atendimento.ia_dt_handoff != null">
                    <fa name="user"></fa> Transferido para humano
                  </span>

                  <span class="badge badge-pill whatsapp_ia_badge_off" *ngIf="atendimento.ia_modo_override == 'DESATIVADO' && atendimento.ia_dt_handoff == null">
                    IA Off
                  </span>
                </div>

                <div class="whatsapp_conversation_client" *ngIf="atendimento.client_name_snapshot">
                  Cliente: {{ atendimento.client_name_snapshot }}
                  <span *ngIf="atendimento.client_codigo_erp_snapshot">| ERP: {{ atendimento.client_codigo_erp_snapshot }}</span>
                </div>
              </div>

              <span class="whatsapp_unread_badge" *ngIf="atendimento.qtde_mensagens_nao_lidas > 0 && !isAtendimentoSelecionado(atendimento)">
                {{ atendimento.qtde_mensagens_nao_lidas }}
              </span>
            </div>
          </button>

          <div class="whatsapp_carregando_mais_conversas" *ngIf="temMaisConversasParaCarregar">
            <i class="fa fa-spinner fa-spin"></i> Carregando mais conversas...
          </div>
        </div>
      </div>

      <div class="whatsapp_chat" *ngIf="atendimentoSelecionado != null">
        <div class="whatsapp_chat_header">
          <div class="d-flex flex-wrap justify-content-between align-items-start">
            <div class="whatsapp_chat_id">
              <div class="whatsapp_avatar whatsapp_avatar_lg">
                <img *ngIf="atendimentoSelecionado.contato_foto_url" [src]="atendimentoSelecionado.contato_foto_url" alt="" class="whatsapp_avatar_foto">
                <ng-container *ngIf="!atendimentoSelecionado.contato_foto_url">{{ getIniciaisAtendimento(atendimentoSelecionado) }}</ng-container>
              </div>

              <div>
                <div class="whatsapp_chat_title">{{ getNomeExibicaoAtendimento(atendimentoSelecionado) }}</div>

                <div class="whatsapp_chat_meta_chips">
                  <span class="whatsapp_meta_chip"><fa name="phone"></fa> {{ atendimentoSelecionado.telefone }}</span>

                  <span class="whatsapp_meta_chip whatsapp_meta_chip_cliente" *ngIf="atendimentoSelecionado.client_name_snapshot">
                    <fa name="link"></fa> {{ atendimentoSelecionado.client_name_snapshot }}
                    <span *ngIf="atendimentoSelecionado.client_codigo_erp_snapshot">· ERP {{ atendimentoSelecionado.client_codigo_erp_snapshot }}</span>

                    <button
                      type="button"
                      class="whatsapp_meta_chip_action"
                      *ngIf="podeGerenciar && atendimentoSelecionado.client_id != null"
                      title="Alterar dados do cliente (abre a ficha completa em nova aba)"
                      (click)="alterarDadosCliente()">
                      <i class="fa fa-id-card-o"></i>
                    </button>

                    <button
                      type="button"
                      class="whatsapp_meta_chip_action"
                      *ngIf="podeGerenciar"
                      title="Trocar cliente vinculado"
                      (click)="abrirPopupTrocarCliente()">
                      <i class="fa fa-pencil"></i>
                    </button>

                    <button
                      type="button"
                      class="whatsapp_meta_chip_action"
                      *ngIf="podeGerenciar"
                      [disabled]="desvinculandoCliente"
                      title="Remover vínculo com o cliente"
                      (click)="desvincularCliente()">
                      <i class="fa" [ngClass]="desvinculandoCliente ? 'fa-spinner fa-spin' : 'fa-times'"></i>
                    </button>

                    <button
                      type="button"
                      class="whatsapp_meta_chip_action"
                      *ngIf="atendimentoSelecionado.client_id != null"
                      title="Clientes vinculados"
                      (click)="abrirPopupClientesVinculados()">
                      <i class="fa fa-users"></i>
                    </button>
                  </span>

                  <span class="whatsapp_meta_chip whatsapp_meta_chip_alerta" *ngIf="atendimentoSelecionado.seller_id_atual == null">
                    <fa name="exclamation-circle"></fa> Aguardando captura
                  </span>

                  <span class="whatsapp_meta_chip" *ngIf="podeVerVendedorResponsavel && getNomeVendedorResponsavel(atendimentoSelecionado) != ''">
                    <fa name="user"></fa> {{ getNomeVendedorResponsavel(atendimentoSelecionado) }}
                  </span>
                </div>

                <div class="whatsapp_obs_row" *ngIf="atendimentoSelecionado.client_id != null">
                  <button
                    class="whatsapp_obs_ghost"
                    type="button"
                    *ngIf="!editandoContatoCallCenter && !contatoCallCenterCliente"
                    (click)="iniciarEdicaoContatoCallCenter()">
                    <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    Adicionar contato
                  </button>

                  <div class="whatsapp_obs_filled" *ngIf="!editandoContatoCallCenter && contatoCallCenterCliente">
                    <svg class="whatsapp_obs_svg whatsapp_obs_pin" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <span class="whatsapp_obs_filled_text">{{ contatoCallCenterCliente }}</span>
                    <span class="whatsapp_obs_filled_actions">
                      <button class="whatsapp_obs_icon_btn" type="button" title="Editar" (click)="iniciarEdicaoContatoCallCenter()">
                        <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path d="M12 20h9"></path>
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
                        </svg>
                      </button>
                      <button class="whatsapp_obs_icon_btn" type="button" title="Remover" (click)="removerContatoCallCenter($event)">
                        <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path d="M3 6h18"></path>
                          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                        </svg>
                      </button>
                    </span>
                  </div>

                  <div class="whatsapp_obs_edit" *ngIf="editandoContatoCallCenter">
                    <input
                      id="whatsapp_contato_callcenter_input"
                      type="text"
                      maxlength="500"
                      [(ngModel)]="textoContatoCallCenterEdicao"
                      [disabled]="salvandoContatoCallCenter"
                      (keydown.enter)="salvarContatoCallCenter()"
                      (keydown.escape)="cancelarEdicaoContatoCallCenter()"
                      placeholder="Nome do contato..." />
                    <button class="whatsapp_obs_edit_btn whatsapp_obs_save" type="button" [disabled]="salvandoContatoCallCenter" (click)="salvarContatoCallCenter()">
                      {{ salvandoContatoCallCenter ? "Salvando..." : "Salvar" }}
                    </button>
                    <button class="whatsapp_obs_edit_btn whatsapp_obs_cancel" type="button" [disabled]="salvandoContatoCallCenter" (click)="cancelarEdicaoContatoCallCenter()">
                      Cancelar
                    </button>
                  </div>

                  <button
                    class="whatsapp_obs_ghost"
                    type="button"
                    *ngIf="!editandoObservacaoGeral && !observacaoGeralCliente"
                    (click)="iniciarEdicaoObservacaoGeral()">
                    <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M12 20h9"></path>
                      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
                    </svg>
                    Adicionar observação
                  </button>

                  <div class="whatsapp_obs_filled" *ngIf="!editandoObservacaoGeral && observacaoGeralCliente">
                    <svg class="whatsapp_obs_svg whatsapp_obs_pin" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M12 20h9"></path>
                      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
                    </svg>
                    <span class="whatsapp_obs_filled_text">{{ observacaoGeralCliente }}</span>
                    <span class="whatsapp_obs_filled_actions">
                      <button class="whatsapp_obs_icon_btn" type="button" title="Editar" (click)="iniciarEdicaoObservacaoGeral()">
                        <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path d="M12 20h9"></path>
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
                        </svg>
                      </button>
                      <button class="whatsapp_obs_icon_btn" type="button" title="Remover" (click)="removerObservacaoGeral($event)">
                        <svg class="whatsapp_obs_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path d="M3 6h18"></path>
                          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                        </svg>
                      </button>
                    </span>
                  </div>

                  <div class="whatsapp_obs_edit" *ngIf="editandoObservacaoGeral">
                    <input
                      id="whatsapp_observacao_geral_input"
                      type="text"
                      maxlength="500"
                      [(ngModel)]="textoObservacaoGeralEdicao"
                      [disabled]="salvandoObservacaoGeral"
                      (keydown.enter)="salvarObservacaoGeral()"
                      (keydown.escape)="cancelarEdicaoObservacaoGeral()"
                      placeholder="Observação sobre o cliente..." />
                    <button class="whatsapp_obs_edit_btn whatsapp_obs_save" type="button" [disabled]="salvandoObservacaoGeral" (click)="salvarObservacaoGeral()">
                      {{ salvandoObservacaoGeral ? "Salvando..." : "Salvar" }}
                    </button>
                    <button class="whatsapp_obs_edit_btn whatsapp_obs_cancel" type="button" [disabled]="salvandoObservacaoGeral" (click)="cancelarEdicaoObservacaoGeral()">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="whatsapp_chat_status_row">
              <div class="whatsapp_status_line">
                <span class="badge badge-pill whatsapp_stage_badge" [ngStyle]="{ 'background-color': getCorEtapaAtendimento(atendimentoSelecionado), 'color': getCorTextoEtapaAtendimento(atendimentoSelecionado) }">
                  {{ getNomeEtapaAtendimento(atendimentoSelecionado) }} {{ getResumoTempo(atendimentoSelecionado) }}
                </span>
              </div>

              <div class="whatsapp_ia_mode" [class.whatsapp_ia_mode_salvando]="iaAtualizandoModo" [class.whatsapp_ia_mode_desativado]="!iaAgenteHabilitado" [title]="iaAgenteHabilitado ? 'Modo do Agente IA nesta conversa (clique novamente no modo destacado para voltar ao padrão da empresa)' : 'O agente esta desativado. Solicite ao Gerente para ativar essa funcao.'">
                <span class="whatsapp_ia_mode_label"><fa name="magic"></fa> IA:</span>
                <button type="button" class="whatsapp_ia_mode_btn" [disabled]="iaAtualizandoModo" [class.whatsapp_ia_mode_auto]="getIaModoEfetivo() == 'AUTO'" [class.whatsapp_ia_mode_herdado]="getIaModoEfetivo() == 'AUTO' && isIaModoHerdado()" (click)="atualizarIaModoConversa('AUTO')">Auto</button>
                <button type="button" class="whatsapp_ia_mode_btn" [disabled]="iaAtualizandoModo" [class.whatsapp_ia_mode_aprovacao]="getIaModoEfetivo() == 'APROVACAO'" [class.whatsapp_ia_mode_herdado]="getIaModoEfetivo() == 'APROVACAO' && isIaModoHerdado()" (click)="atualizarIaModoConversa('APROVACAO')">Aprovação</button>
                <button type="button" class="whatsapp_ia_mode_btn" [disabled]="iaAtualizandoModo" [class.whatsapp_ia_mode_off]="getIaModoEfetivo() == 'DESATIVADO'" [class.whatsapp_ia_mode_herdado]="getIaModoEfetivo() == 'DESATIVADO' && isIaModoHerdado()" (click)="atualizarIaModoConversa('DESATIVADO')">Off</button>
                <span class="whatsapp_ia_mode_hint" *ngIf="iaAtualizandoModo"><i class="fa fa-spinner fa-spin"></i></span>
                <span class="whatsapp_ia_mode_hint" *ngIf="!iaAtualizandoModo && isIaModoHerdado()">padrão</span>
              </div>
            </div>
          </div>

          <div class="whatsapp_chat_controls mt-1" *ngIf="podeGerenciar">
            <div class="whatsapp_stage_select" *ngIf="podeGerenciarEtapaAtendimento(atendimentoSelecionado)">
              <select class="form-control form-control-sm" [(ngModel)]="etapaDestinoId" (ngModelChange)="moverEtapaSelecionada()">
                <option *ngFor="let etapa of etapas" [ngValue]="etapa.id">{{ etapa.nome }}</option>
              </select>
            </div>

            <div class="whatsapp_stage_actions">
              <div class="whatsapp_stage_actions_left" *ngIf="podeGerenciarEtapaAtendimento(atendimentoSelecionado)">
                <button class="btn btn-sm btn-outline-danger mr-2 mb-1" type="button" *ngIf="podeExibirBotoesConclusao(atendimentoSelecionado)" (click)="alternarFormularioPerda()">
                  Perda
                </button>

                <button class="btn btn-sm btn-outline-success mr-2 mb-1" type="button" *ngIf="podeExibirBotoesConclusao(atendimentoSelecionado)" (click)="concluirComoGanho()">
                  Ganho
                </button>
              </div>

              <div class="whatsapp_stage_actions_right">
                <button class="btn btn-sm btn-outline-info mr-2 mb-1" type="button" *ngIf="podeEncaminharAtendimento()" (click)="abrirPopupEncaminhar()">
                  Encaminhar
                </button>

                <button class="btn btn-sm btn-outline-primary mr-2 mb-1" type="button" *ngIf="podeVincularCliente()" (click)="abrirPopupVincularCliente()">
                  Vincular Cliente
                </button>

                <button class="btn btn-sm btn-outline-secondary mr-2 mb-1" type="button" *ngIf="podeAbrirAnalise()" (click)="iniciarAnaliseCliente()">
                  Analise
                </button>

                <button class="btn btn-sm btn-outline-info mr-2 mb-1 whatsapp_call_button" type="button" *ngIf="podeAbrirLigacao()" [disabled]="abrindoLigacao" (click)="iniciarLigacaoCliente()" title="Ligar para o cliente">
                  <fa name="phone"></fa>
                  <span>{{ abrindoLigacao ? 'Abrindo...' : 'Ligar' }}</span>
                </button>

                <button class="btn btn-sm btn-outline-success whatsapp_action_primary mb-1" type="button" *ngIf="podeExibirBotoesConclusao(atendimentoSelecionado)" [disabled]="!podeAbrirNovoPedido()" (click)="iniciarNovoPedido()">
                  Novo Pedido
                </button>
              </div>
            </div>
          </div>

          <div class="card card-body mt-2 card_perda" *ngIf="exibirFormularioPerda && podeGerenciarEtapaAtendimento(atendimentoSelecionado)">
            <div class="row">
              <div class="col-md-4 mb-2">
                <label class="mb-1">Motivo da perda</label>
                <select class="form-control form-control-sm" [(ngModel)]="motivoPerdaId">
                  <option [ngValue]="null">Selecione...</option>
                  <option *ngFor="let motivo of motivosPerda" [ngValue]="motivo.id">{{ motivo.name }}</option>
                </select>
              </div>

              <div class="col-md-6 mb-2">
                <label class="mb-1">Complemento</label>
                <input class="form-control form-control-sm" type="text" [(ngModel)]="complementoPerda" maxlength="2000" />
              </div>

              <div class="col-md-2 mb-2 d-flex align-items-end">
                <button class="btn btn-sm btn-danger w-100" type="button" (click)="concluirComoPerda()">
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Banner de handoff da IA -->
        <div class="whatsapp_handoff_banner" *ngIf="atendimentoSelecionado.ia_dt_handoff != null">
          <div class="whatsapp_capture_banner_text">
            <div class="whatsapp_handoff_banner_icon"><i class="fa fa-user"></i></div>
            <div>
              <b>A IA transferiu esta conversa para atendimento humano</b>
              <small>{{ atendimentoSelecionado.ia_dt_handoff | date:'dd/MM HH:mm' }} · A IA está pausada nesta conversa até você reativá-la.</small>
            </div>
          </div>

          <div class="whatsapp_handoff_banner_acoes">
            <button class="whatsapp_handoff_banner_btn" type="button" [disabled]="iaAtualizandoModo" (click)="reativarIaAposHandoff()">
              <i class="fa fa-magic"></i> {{ iaReativandoHandoff ? 'Reativando...' : 'Reativar IA' }}
            </button>

            <button class="whatsapp_handoff_banner_fechar" type="button" [disabled]="iaAtualizandoModo" (click)="dispensarAvisoHandoff()" title="Fechar aviso e manter a IA desativada nesta conversa">
              <i class="fa" [ngClass]="iaDispensandoHandoff ? 'fa-spinner fa-spin' : 'fa-times'"></i>
            </button>
          </div>
        </div>

        <!-- Banner de captura -->
        <div class="whatsapp_capture_banner" *ngIf="isAtendimentoCapturavel(atendimentoSelecionado)">
          <div class="whatsapp_capture_banner_text">
            <div class="whatsapp_capture_banner_icon"><fa name="hand-paper-o"></fa></div>
            <div>
              <b>Este atendimento ainda não tem responsável</b>
              <small>Capture para responder o cliente pelo chat.</small>
            </div>
          </div>

          <button class="whatsapp_capture_banner_btn" type="button" (click)="capturarAtendimento()">
            <fa name="bolt"></fa> Capturar Atendimento
          </button>
        </div>

        <div class="whatsapp_messages" #mensagensContainer>
          <div class="whatsapp_empty" role="status" aria-live="polite" *ngIf="carregandoMensagens">Carregando mensagens…</div>
          <div class="whatsapp_empty" *ngIf="mensagens.length == 0 && !carregandoMensagens">
            Nenhuma mensagem encontrada para este atendimento.
          </div>

          <div class="whatsapp_load_more" *ngIf="temMaisMensagens && !carregandoMensagens">
            <button class="btn btn-sm whatsapp_load_more_button" type="button" (click)="carregarMaisMensagens()" [disabled]="carregandoMaisMensagens">
              {{ carregandoMaisMensagens ? 'Carregando...' : 'Carregar mais mensagens' }}
            </button>
          </div>

          <div
            class="whatsapp_message"
            [id]="'whatsapp_msg_' + mensagem.id"
            *ngFor="let mensagem of mensagens"
            [ngClass]="{
              'whatsapp_message_outbound': mensagem.direction == 'OUTBOUND' && !isMensagemInterna(mensagem),
              'whatsapp_message_inbound': mensagem.direction == 'INBOUND' && !isMensagemInterna(mensagem),
              'whatsapp_message_internal': isMensagemInterna(mensagem),
              'whatsapp_message_destacada': mensagemDestacadaId == mensagem.id
            }">
            <div class="whatsapp_message_menu_wrapper" [class.whatsapp_message_menu_wrapper_aberto]="mensagemMenuAbertaId == mensagem.id" *ngIf="!isMensagemInterna(mensagem) && !isMensagemDeletada(mensagem)">
              <button
                class="whatsapp_message_menu_button"
                type="button"
                (click)="alternarMenuMensagem(mensagem, $event)"
                title="Mais opções">
                <svg class="whatsapp_message_menu_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M6 9l6 6 6-6"></path>
                </svg>
              </button>

              <div class="whatsapp_message_menu" *ngIf="mensagemMenuAbertaId == mensagem.id" (click)="$event.stopPropagation()">
                <button class="whatsapp_message_menu_item" type="button" *ngIf="podeAlterarMensagem(mensagem, false)" [disabled]="mensagemAlterandoId != null" (click)="iniciarEdicaoMensagem(mensagem, $event)">
                  <fa name="pencil"></fa><span>Editar</span>
                </button>
                <button class="whatsapp_message_menu_item" type="button" *ngIf="podeAlterarMensagem(mensagem, true)" [disabled]="mensagemAlterandoId != null" (click)="apagarMensagem(mensagem, $event)">
                  <fa name="trash"></fa><span>Apagar para todos</span>
                </button>                <button class="whatsapp_message_menu_item" type="button" (click)="responderMensagem(mensagem, $event)">
                  <svg class="whatsapp_message_menu_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M9 14 4 9l5-5"></path>
                    <path d="M4 9h9a6 6 0 0 1 6 6v2"></path>
                  </svg>
                  <span>Responder</span>
                </button>
              </div>
            </div>

            <div class="whatsapp_message_text" [attr.inert]="isMensagemDeletada(mensagem) ? '' : null" [class.whatsapp_message_deleted]="isMensagemDeletada(mensagem)">
              <div class="whatsapp_internal_tag" *ngIf="isMensagemInterna(mensagem)">
                Mensagem interna
              </div>

              <div
                class="whatsapp_message_quote"
                *ngIf="mensagem.reply_to_preview"
                (click)="irParaMensagem(mensagem.reply_to_message_id, $event)">
                <span class="whatsapp_message_quote_text">{{ mensagem.reply_to_preview }}</span>
              </div>

              <ng-container *ngIf="isMensagemVideo(mensagem); else mensagemImagemOuOutros">
                <div class="whatsapp_document_card whatsapp_document_card_pending" *ngIf="videoPrecisaDownload(mensagem); else videoDisponivel">
                  <span class="whatsapp_document_icon whatsapp_video_icon">
                    <fa name="video-camera"></fa>
                  </span>
                  <span class="whatsapp_document_info">
                    <span class="whatsapp_document_label">Vídeo</span>
                    <span class="whatsapp_document_name">Vídeo recebido</span>
                  </span>
                  <button class="btn btn-sm whatsapp_document_download" type="button" (click)="baixarVideoRecebido(mensagem, $event)" [disabled]="isBaixandoVideo(mensagem)">
                    {{ isBaixandoVideo(mensagem) ? 'Baixando...' : 'Baixar' }}
                  </button>
                </div>

                <ng-template #videoDisponivel>
                  <div class="whatsapp_video_card">
                    <video class="whatsapp_video_player" [src]="getUrlVideo(mensagem)" controls preload="metadata"></video>
                    <button class="btn btn-sm whatsapp_document_download mt-2" type="button" (click)="abrirVideo(mensagem, $event)">
                      Abrir
                    </button>
                    <div class="whatsapp_image_caption" *ngIf="getLegendaVideo(mensagem)">
                      {{ getLegendaVideo(mensagem) }}
                    </div>
                  </div>
                </ng-template>
              </ng-container>

              <ng-template #mensagemImagemOuOutros>
              <ng-container *ngIf="isMensagemImagem(mensagem); else mensagemDocumentoOuTexto">
                <div class="whatsapp_image_pending_card" *ngIf="imagemPrecisaDownload(mensagem); else imagemDisponivel">
                  <span class="whatsapp_document_icon whatsapp_image_pending_icon">
                    <fa name="image"></fa>
                  </span>
                  <span class="whatsapp_document_info">
                    <span class="whatsapp_document_label">Imagem</span>
                    <span class="whatsapp_document_name">Imagem recebida</span>
                  </span>
                  <button
                    class="btn btn-sm whatsapp_document_download"
                    type="button"
                    (click)="baixarImagemRecebida(mensagem, $event)"
                    [disabled]="isBaixandoImagem(mensagem)">
                    {{ isBaixandoImagem(mensagem) ? 'Baixando...' : 'Baixar' }}
                  </button>
                </div>

                <ng-template #imagemDisponivel>
                  <a class="whatsapp_image_link" [href]="getUrlImagem(mensagem)" target="_blank" rel="noopener noreferrer" (click)="abrirImagem(mensagem, $event)">
                    <img class="whatsapp_image_thumb" [src]="getUrlImagem(mensagem)" alt="Imagem enviada" />
                    <span class="btn btn-sm whatsapp_image_open">Abrir</span>
                  </a>
                  <div class="whatsapp_image_caption" *ngIf="getLegendaImagem(mensagem)">
                    <app-texto-com-links [texto]="getLegendaImagem(mensagem)"></app-texto-com-links>
                  </div>
                </ng-template>
              </ng-container>
              </ng-template>

              <ng-template #mensagemDocumentoOuTexto>
              <ng-container *ngIf="isMensagemDocumento(mensagem); else mensagemAudioOuTexto">
                <div class="whatsapp_document_card" [ngClass]="{ 'whatsapp_document_card_pending': documentoPrecisaDownload(mensagem) }">
                  <span class="whatsapp_document_icon">
                    <fa name="file-text-o"></fa>
                  </span>
                  <span class="whatsapp_document_info">
                    <span class="whatsapp_document_label">Documento</span>
                    <span class="whatsapp_document_name">{{ getNomeDocumento(mensagem) }}</span>
                    <span class="whatsapp_document_caption" *ngIf="getLegendaDocumento(mensagem)">
                      <app-texto-com-links [texto]="getLegendaDocumento(mensagem)"></app-texto-com-links>
                    </span>
                  </span>
                  <button
                    class="btn btn-sm whatsapp_document_download"
                    type="button"
                    *ngIf="documentoPrecisaDownload(mensagem)"
                    (click)="baixarDocumentoRecebido(mensagem, $event)"
                    [disabled]="isBaixandoDocumento(mensagem)">
                    {{ isBaixandoDocumento(mensagem) ? 'Baixando...' : 'Baixar' }}
                  </button>
                  <a
                    class="btn btn-sm whatsapp_document_download"
                    *ngIf="!documentoPrecisaDownload(mensagem)"
                    [href]="getUrlDocumento(mensagem)"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="abrirDocumento(mensagem, $event)">
                    Abrir
                  </a>
                </div>
              </ng-container>
              </ng-template>

              <ng-template #mensagemAudioOuTexto>
                <ng-container *ngIf="isMensagemAudio(mensagem); else mensagemTextoPadrao">
                  <div class="whatsapp_audio_card" *ngIf="!audioPrecisaDownload(mensagem); else audioPendenteDownload">
                    <button class="whatsapp_audio_play" [ngClass]="{ 'whatsapp_audio_play_pause': isAudioTocando(mensagem) }" type="button" (click)="alternarAudioMensagem(mensagem, $event)" [title]="isAudioTocando(mensagem) ? 'Pausar áudio' : 'Reproduzir áudio'">
                      <fa [name]="isAudioTocando(mensagem) ? 'pause' : 'play'"></fa>
                    </button>

                    <div class="whatsapp_audio_body">
                      <div class="whatsapp_audio_wave">
                        <span
                          *ngFor="let altura of audioWaveformBars"
                          class="whatsapp_audio_wave_bar"
                          [style.height.px]="altura"></span>
                        <span class="whatsapp_audio_progress" [style.width.%]="getPercentualAudio(mensagem)"></span>
                        <span class="whatsapp_audio_thumb" [style.left.%]="getPercentualAudio(mensagem)"></span>
                      </div>

                      <div class="whatsapp_audio_times">
                        <span>{{ getTempoAudio(mensagem) }}</span>
                        <span>{{ getDuracaoAudio(mensagem) }}</span>
                      </div>
                    </div>
                  </div>
                  <ng-template #audioPendenteDownload>
                    <div class="whatsapp_document_card whatsapp_document_card_pending whatsapp_audio_pending_card">
                      <span class="whatsapp_document_icon whatsapp_audio_pending_icon">
                        <fa name="microphone"></fa>
                      </span>
                      <span class="whatsapp_document_info">
                        <span class="whatsapp_document_label">Áudio</span>
                        <span class="whatsapp_document_name">Áudio recebido</span>
                      </span>
                      <button class="btn btn-sm whatsapp_document_download" type="button" (click)="baixarAudioRecebido(mensagem, $event)" [disabled]="isBaixandoAudio(mensagem)">
                        {{ isBaixandoAudio(mensagem) ? 'Baixando...' : 'Baixar' }}
                      </button>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-template>

              <ng-template #mensagemTextoPadrao>
                <ng-container *ngIf="isMensagemTemplate(mensagem); else mensagemNaoTemplate">
                  <div class="whatsapp_template_message">
                    <div class="whatsapp_template_header" *ngIf="getCabecalhoTemplateMensagem(mensagem)">
                      {{ getCabecalhoTemplateMensagem(mensagem) }}
                    </div>
                    <div class="whatsapp_template_body"><app-texto-com-links [texto]="getTextoMensagemSemAtendente(mensagem)"></app-texto-com-links></div>
                    <div class="whatsapp_template_buttons" *ngIf="getBotoesTemplateMensagem(mensagem).length > 0">
                      <div class="whatsapp_template_button" *ngFor="let botao of getBotoesTemplateMensagem(mensagem)">
                        {{ botao.text }}
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-template #mensagemNaoTemplate>
                  <ng-container *ngIf="isMensagemLocalizacao(mensagem); else mensagemContatoOuResposta">
                    <div class="whatsapp_document_card whatsapp_location_card">
                      <span class="whatsapp_document_icon whatsapp_location_icon">
                        <fa name="map-marker"></fa>
                      </span>
                      <span class="whatsapp_document_info">
                        <span class="whatsapp_document_label">Localização</span>
                        <span class="whatsapp_document_name">{{ getTextoLocalizacao(mensagem) }}</span>
                        <span class="whatsapp_card_subtitle" *ngIf="getEnderecoLocalizacao(mensagem)">{{ getEnderecoLocalizacao(mensagem) }}</span>
                      </span>
                      <a class="btn btn-sm whatsapp_document_download" *ngIf="getUrlLocalizacao(mensagem)" [href]="getUrlLocalizacao(mensagem)" target="_blank" rel="noopener noreferrer">
                        Abrir mapa
                      </a>
                    </div>
                  </ng-container>

                  <ng-template #mensagemContatoOuResposta>
                  <ng-container *ngIf="isMensagemContato(mensagem); else mensagemRespostaOuTexto">
                    <div class="whatsapp_document_card whatsapp_contact_card" *ngFor="let contato of getContatosMensagem(mensagem); trackBy: trackByContatoMensagem">
                      <span class="whatsapp_document_icon whatsapp_contact_icon">
                        <fa name="address-card-o"></fa>
                      </span>
                      <span class="whatsapp_document_info">
                        <span class="whatsapp_document_label">Contato</span>
                        <span class="whatsapp_document_name">{{ contato.name }}</span>
                                                <span class="whatsapp_card_subtitle" *ngIf="contato.phone">{{ contato.phone }}</span>
                        <button type="button" class="btn btn-sm btn-outline-success mt-2 whatsapp_contact_conversar" *ngIf="contato.phone && !isMensagemDeletada(mensagem)" [disabled]="abrindoNovoAtendimento" (click)="conversarComContato(contato, $event, mensagem)">Conversar</button>
                      </span>
                    </div>
                  </ng-container>
                  </ng-template>

                  <ng-template #mensagemRespostaOuTexto>
                  <ng-container *ngIf="isMensagemRespostaBotao(mensagem); else mensagemTextoComum">
                    <div class="whatsapp_button_reply_tag">Opção selecionada</div>
                    <span><app-texto-com-links [texto]="getTextoRespostaBotao(mensagem)"></app-texto-com-links></span>
                  </ng-container>
                </ng-template>
                </ng-template>

                <ng-template #mensagemTextoComum>
                  <div class="whatsapp_message_seller" *ngIf="mensagem.direction != 'OUTBOUND' && !isMensagemInterna(mensagem) && getNomeAtendenteMensagem(mensagem) != null">
                    {{ getNomeAtendenteMensagem(mensagem) }}:
                  </div>
                  <span><app-texto-com-links [texto]="getTextoMensagemSemAtendente(mensagem)"></app-texto-com-links></span>
                </ng-template>
              </ng-template>
            </div>
            <div class="whatsapp_message_edit" *ngIf="mensagemEditandoId === mensagem.id && !isMensagemDeletada(mensagem)">
              <label [attr.for]="'editar-msg-' + mensagem.id">Editar mensagem</label>
              <textarea class="form-control" [id]="'editar-msg-' + mensagem.id" [(ngModel)]="textoEdicaoMensagem" [disabled]="mensagemAlterandoId != null" rows="3"></textarea>
              <small>Disponível até 15 minutos após o envio.</small>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="mensagemAlterandoId != null" (click)="mensagemEditandoId = null">Cancelar</button>
                <button type="button" class="btn btn-sm btn-primary ml-2" [disabled]="mensagemAlterandoId != null || !textoEdicaoMensagem.trim() || !podeAlterarMensagem(mensagem, false)" (click)="salvarEdicaoMensagem(mensagem)">Salvar edição</button>
              </div>
            </div>
            <div class="whatsapp_message_meta">
              <span class="whatsapp_message_action_tag" *ngIf="isMensagemDeletada(mensagem); else tagEditada">Deletada · </span>
              <ng-template #tagEditada><span class="whatsapp_message_action_tag" *ngIf="mensagem.dt_editada">Editada · </span></ng-template>
              {{ mensagem.dt_mensagem | date:'dd/MM/yyyy HH:mm' }}
              <span *ngIf="mensagem.direction == 'OUTBOUND' && !isMensagemInterna(mensagem) && !isMensagemDeletada(mensagem) && mensagem.status_whatsapp">| {{ mensagem.status_whatsapp }}</span>
            </div>
            <div class="whatsapp_message_actions" *ngIf="podeReenviarMensagem(mensagem)">
              <button class="btn btn-sm btn-outline-danger" type="button" (click)="reenviarMensagem(mensagem)">
                Reenviar
              </button>
            </div>
          </div>
        </div>

        <!-- IA: gerando resposta -->
        <div class="whatsapp_ia_typing" *ngIf="iaGerandoConversas[atendimentoSelecionado.id] && iaSugestaoPendente == null">
          <fa name="magic"></fa>
          <span>A IA está gerando uma resposta</span>
          <span class="whatsapp_ia_typing_dots"><span>●</span><span>●</span><span>●</span></span>
        </div>

        <!-- IA: sugestão aguardando aprovação -->
        <div class="whatsapp_ia_approval" *ngIf="iaSugestaoPendente != null">
          <div class="whatsapp_ia_approval_head">
            <div class="whatsapp_ia_approval_title">
              <fa name="hourglass-half"></fa> {{ isEtapaFluxoPedido() ? 'Próxima etapa do pedido guiado — aguardando sua aprovação' : 'Resposta sugerida pela IA — aguardando sua aprovação' }}
            </div>
            <div class="whatsapp_ia_approval_meta" *ngIf="iaSugestaoPendente.modelo_ia != null">
              {{ iaSugestaoPendente.data_criacao | date: 'dd/MM HH:mm' }} · {{ iaSugestaoPendente.modelo_ia }}
            </div>
          </div>

          <div class="whatsapp_ia_approval_text" *ngIf="!iaEditandoSugestao">{{ iaSugestaoPendente.resposta_texto }}</div>

          <textarea
            *ngIf="iaEditandoSugestao"
            class="form-control whatsapp_ia_approval_edit"
            rows="4"
            maxlength="4000"
            [(ngModel)]="iaTextoEdicao"></textarea>

          <div class="whatsapp_ia_approval_actions">
            <button class="btn btn-sm whatsapp_ia_btn_aprovar" type="button" [disabled]="iaProcessandoAcao" (click)="aprovarIaSugestao()">
              <fa name="check"></fa> {{ iaProcessandoAcao ? 'Enviando...' : 'Aprovar e Enviar' }}
            </button>

            <button class="btn btn-sm whatsapp_ia_btn_ghost" type="button" *ngIf="!iaEditandoSugestao && !isEtapaFluxoPedido()" [disabled]="iaProcessandoAcao" (click)="editarIaSugestao()">
              <fa name="pencil"></fa> Editar
            </button>

            <button class="btn btn-sm whatsapp_ia_btn_ghost" type="button" *ngIf="iaEditandoSugestao" [disabled]="iaProcessandoAcao" (click)="cancelarEdicaoIaSugestao()">
              Cancelar edição
            </button>

            <button class="btn btn-sm whatsapp_ia_btn_recusar" type="button" [disabled]="iaProcessandoAcao" (click)="recusarIaSugestao()">
              <fa name="times"></fa> {{ isEtapaFluxoPedido() ? 'Recusar e cancelar pedido' : 'Recusar' }}
            </button>

            <button class="btn btn-sm whatsapp_ia_btn_ghost" type="button" *ngIf="!isEtapaFluxoPedido()" [disabled]="iaGerandoSugestao || iaProcessandoAcao" (click)="gerarOutraIaSugestao()">
              <fa name="refresh"></fa> {{ iaGerandoSugestao ? 'Gerando...' : 'Gerar outra' }}
            </button>
          </div>
        </div>

        <div class="whatsapp_composer">
          <div class="whatsapp_reply_banner" *ngIf="mensagemRespondendoA != null">
            <div class="whatsapp_reply_banner_bar"></div>
            <div class="whatsapp_reply_banner_body">
              <div class="whatsapp_reply_banner_title">Respondendo a {{ mensagemRespondendoA.direction == 'OUTBOUND' ? 'você' : getNomeExibicaoAtendimento(atendimentoSelecionado) }}</div>
              <div class="whatsapp_reply_banner_text">{{ mensagemRespondendoA.texto }}</div>
            </div>

            <button class="whatsapp_reply_banner_close" type="button" (click)="cancelarResposta()" title="Cancelar resposta">
              &times;
            </button>
          </div>

          <div class="whatsapp_order_return" *ngIf="pedidoRetornoNumero != null && atendimentoSelecionado != null && atendimentoSelecionado.id == pedidoRetornoAtendimentoId">
            <div>
              <div class="whatsapp_order_return_title">{{ pedidoRetornoMensagem }}</div>
              <div class="whatsapp_order_return_meta">Pedido nro {{ pedidoRetornoNumero }}</div>
            </div>

            <div class="whatsapp_order_return_actions">
              <button class="btn btn-sm btn-outline-danger" type="button" (click)="enviarPdfPedidoCliente()" [disabled]="enviandoPdfPedido" [attr.aria-busy]="enviandoPdfPedido" title="Enviar PDF do pedido ao cliente" aria-label="Enviar PDF do pedido ao cliente">
                <i class="fa" [ngClass]="enviandoPdfPedido ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'" aria-hidden="true"></i>
                <span *ngIf="enviandoPdfPedido"> Enviando...</span>
              </button>

              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="limparRetornoPedido()">
                X
              </button>
            </div>
          </div>

          <div class="whatsapp_composer_bar">
            <div class="whatsapp_attach_menu_wrapper">
              <button class="btn btn-sm whatsapp_attach_button" type="button" (click)="alternarMenuAnexo($event)" [disabled]="!podeEnviarMensagem()" title="Anexar">
                <span class="whatsapp_attach_plus">+</span>
              </button>

              <div class="whatsapp_attach_menu" *ngIf="mostrarMenuAnexo">
                <button class="whatsapp_attach_menu_item" type="button" *ngIf="isConversaUazapi()" (click)="abrirEnvioContato($event)">
                  <span class="whatsapp_attach_menu_icon whatsapp_attach_menu_icon_contact">
                    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <circle cx="12" cy="8" r="4"></circle>
                      <path d="M5 21v-3a7 7 0 0 1 14 0v3"></path>
                    </svg>
                  </span><span>Contato</span>
                </button>
                <button class="whatsapp_attach_menu_item" type="button" (click)="abrirSelecaoDocumento($event)">
                  <span class="whatsapp_attach_menu_icon whatsapp_attach_menu_icon_document">
                    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M14 3H5v18h14V8z M14 3v5h5 M8 12h8 M8 16h8"></path>
                    </svg>
                  </span>
                  <span>Documento</span>
                </button>

                <button class="whatsapp_attach_menu_item" type="button" (click)="abrirSelecaoImagem($event)">
                  <span class="whatsapp_attach_menu_icon whatsapp_attach_menu_icon_image">
                    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                      <circle cx="8" cy="8" r="1.5"></circle>
                      <path d="m3 17 5-5 4 4 4-6 5 7"></path>
                    </svg>
                  </span>
                  <span>Fotos e imagens</span>
                </button>
              </div>
            </div>

            <div class="whatsapp_emoji_wrapper" *ngIf="!gravandoAudio">
              <button class="btn btn-sm whatsapp_emoji_button" type="button" (click)="alternarSeletorEmoji($event)" [class.active]="mostrarSeletorEmoji" [disabled]="!podeEnviarMensagem()" title="Emoji">
                <svg class="whatsapp_action_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <circle cx="12" cy="12" r="9"></circle>
                  <circle cx="9" cy="10" r="1.15" class="whatsapp_action_svg_fill"></circle>
                  <circle cx="15" cy="10" r="1.15" class="whatsapp_action_svg_fill"></circle>
                  <path d="M8.2 14.1c.85 1.45 2.15 2.2 3.8 2.2s2.95-.75 3.8-2.2"></path>
                </svg>
              </button>

              <div class="whatsapp_emoji_panel" *ngIf="mostrarSeletorEmoji">
                <header class="whatsapp_emoji_tabs">
                  <button
                    type="button"
                    *ngFor="let categoria of categoriasEmoji"
                    [class.active]="categoriaEmojiSelecionada == categoria.id"
                    [title]="categoria.label"
                    (click)="selecionarCategoriaEmoji(categoria.id, $event)">
                    <fa [name]="categoria.icon"></fa>
                  </button>
                </header>

                <div class="whatsapp_emoji_search">
                  <fa name="search"></fa>
                  <input
                    type="text"
                    [(ngModel)]="filtroEmoji"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Pesquisar emoji" />
                </div>

                <div class="whatsapp_emoji_section_title">
                  {{ obterTituloCategoriaEmojiSelecionada() }}
                </div>

                <div class="whatsapp_emoji_grid">
                  <button
                    type="button"
                    *ngFor="let emoji of obterEmojisDaCategoriaSelecionada()"
                    class="whatsapp_emoji_item"
                    (click)="inserirEmoji(emoji, $event)">
                    {{ emoji }}
                  </button>
                </div>
              </div>
            </div>

            <input
              #documentInput
              type="file"
              hidden
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.ppt,.pptx"
              (change)="selecionarDocumento($event)" />

            <input
              #imageInput
              type="file"
              hidden
              accept="image/jpeg,image/png,image/webp"
              (change)="selecionarImagem($event)" />

            <div class="whatsapp_audio_recording" *ngIf="gravandoAudio">
              <span class="whatsapp_audio_recording_dot"></span>
              <span>Gravando áudio {{ getTempoGravacaoAudio() }}</span>
              <small>Clique em enviar para concluir ou no microfone para cancelar.</small>
            </div>

            <textarea
              #mensagemInput
              *ngIf="!gravandoAudio"
              class="form-control whatsapp_composer_input"
              rows="1"
              maxlength="4000"
              [(ngModel)]="textoMensagem"
              [disabled]="!podeEnviarMensagem()"
              (keydown.enter)="onMensagemEnter($event)"
              (paste)="onMensagemPaste($event)"
              placeholder="Digite uma mensagem de texto"></textarea>

            <button
              class="btn btn-sm whatsapp_mic_button"
              type="button"
              *ngIf="podeUsarTemplateMensagem()"
              (click)="abrirPopupTemplatesSelecionar()"
              title="Usar template">
              <i class="fa fa-file-text-o"></i>
            </button>

            <button
              class="btn btn-sm whatsapp_mic_button"
              type="button"
              (click)="alternarGravacaoAudio($event)"
              [class.whatsapp_mic_button_recording]="gravandoAudio"
              [disabled]="!podeEnviarMensagem() || processandoAudio"
              title="Gravar áudio">
              <svg class="whatsapp_action_svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M12 14.2c1.95 0 3.35-1.45 3.35-3.45V6.4C15.35 4.45 13.95 3 12 3S8.65 4.45 8.65 6.4v4.35c0 2 1.4 3.45 3.35 3.45Z"></path>
                <path d="M5.8 10.4c0 3.45 2.55 6 6.2 6s6.2-2.55 6.2-6"></path>
                <path d="M12 16.4V21"></path>
                <path d="M9 21h6"></path>
              </svg>
            </button>

            <button class="btn btn_formulario btn-sm whatsapp_send_button" type="button" (click)="enviarMensagem()" [disabled]="!podeEnviarMensagem() || processandoAudio || (!gravandoAudio && textoMensagem.trim() == '')">
              <span class="whatsapp_send_icon">&#10148;</span>
            </button>
          </div>

          <div class="whatsapp_composer_hint">
            <button class="btn btn-sm whatsapp_template_button mr-2" type="button" *ngIf="podeEnviarTemplateMarketing()" (click)="abrirPopupTemplateMarketing()">
              Enviar template Marketing
            </button>
          </div>
        </div>
      </div>

      <div class="whatsapp_empty flex-grow-1" *ngIf="atendimentoSelecionado == null">
        Selecione uma conversa para abrir o atendimento.
      </div>
    </div>

    <div class="whatsapp_analysis_overlay whatsapp_image_preview_overlay" *ngIf="exibirPreviewImagemEnvio">
      <div class="whatsapp_image_preview_modal">
        <div class="whatsapp_image_preview_header">
          <button class="btn whatsapp_image_preview_close" type="button" (click)="fecharPreviewImagemEnvio()">
            ×
          </button>
          <div class="whatsapp_image_preview_title">Enviar imagem</div>
        </div>

        <div class="whatsapp_image_preview_body">
          <img class="whatsapp_image_preview_img" [src]="imagemPreviewUrl" alt="Prévia da imagem" />
        </div>

        <div class="whatsapp_image_preview_footer">
          <textarea
            class="form-control whatsapp_image_preview_caption"
            rows="1"
            maxlength="1024"
            [(ngModel)]="imagemPreviewLegenda"
            placeholder="Digite uma mensagem"></textarea>

          <button class="btn whatsapp_image_preview_send" type="button" (click)="confirmarEnvioImagemPreview()">
            <span class="whatsapp_send_icon">&#10148;</span>
          </button>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupUazapiStatus">
      <div class="whatsapp_link_modal whatsapp_uazapi_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Conexao da instancia</div>
            <div class="whatsapp_analysis_subtitle">Status da instancia do vendedor.</div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupUazapiStatus()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <div class="alert alert-danger" *ngIf="mensagemErroUazapi != ''">
            {{ mensagemErroUazapi }}
          </div>

          <div class="uazapi_status_panel" [ngClass]="getClasseStatusUazapi()">
            <div>
              <div class="uazapi_status_label">Status</div>
              <div class="uazapi_status_value">{{ statusUazapi != null && statusUazapi.status ? statusUazapi.status : getTextoStatusUazapi() }}</div>
            </div>
            <div>
              <div class="uazapi_status_label">Instancia</div>
              <div class="uazapi_status_value">{{ statusUazapi != null && statusUazapi.instance_name ? statusUazapi.instance_name : '-' }}</div>
            </div>
          </div>

          <div class="alert alert-warning mt-3" *ngIf="statusUazapi != null && statusUazapi.configuracao_inexistente">
            Entre em contato com a NAPIS para configurar a instancia do vendedor para uso.
          </div>

          <div class="uazapi_qrcode_area" *ngIf="(statusUazapi == null || !statusUazapi.conectado) && (statusUazapi == null || !statusUazapi.configuracao_inexistente)">
            <div class="text-muted mb-2">
              O QR Code expira em ate 2 minutos e sera atualizado automaticamente enquanto esta janela estiver aberta.
            </div>

            <img *ngIf="temQrCodeUazapi()" class="uazapi_qrcode_img" [src]="getQrCodeUazapiSrc()" alt="QR Code da instancia" />

            <div class="uazapi_qrcode_placeholder" *ngIf="!temQrCodeUazapi()">
              QR Code nao disponivel. Clique em atualizar QR Code para solicitar a conexao da instancia.
            </div>

            <div class="uazapi_paircode" *ngIf="statusUazapi != null && statusUazapi.paircode">
              Codigo de pareamento: <strong>{{ statusUazapi.paircode }}</strong>
            </div>
          </div>

          <div class="uazapi_connected_box" *ngIf="statusUazapi != null && statusUazapi.conectado">
            Instancia conectada e pronta para envio.
          </div>

          <div class="d-flex flex-wrap justify-content-end mt-3">
            <button class="btn btn-sm btn-outline-secondary mr-2 mb-2" type="button" (click)="carregarStatusUazapi(false)" [disabled]="carregandoStatusUazapi" *ngIf="statusUazapi == null || !statusUazapi.configuracao_inexistente">
              {{ carregandoStatusUazapi ? 'Consultando...' : 'Atualizar status' }}
            </button>

            <button class="btn btn-sm btn-outline-primary mr-2 mb-2" type="button" (click)="atualizarQrCodeUazapi()" [disabled]="atualizandoQrCodeUazapi || carregandoStatusUazapi" *ngIf="(statusUazapi == null || (!statusUazapi.conectado && !statusUazapi.configuracao_inexistente))">
              {{ atualizandoQrCodeUazapi ? 'Gerando...' : 'Atualizar QR Code' }}
            </button>

            <button class="btn btn-sm whatsapp_link_primary_button mb-2" type="button" (click)="fecharPopupUazapiStatus()">
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupTemplate">
      <div class="whatsapp_link_modal whatsapp_template_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Enviar Template Marketing</div>
            <div class="whatsapp_analysis_subtitle" *ngIf="atendimentoSelecionado != null">
              {{ getNomeExibicaoAtendimento(atendimentoSelecionado) }} - {{ atendimentoSelecionado.telefone }}
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupTemplateMarketing()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <div class="alert alert-info whatsapp_template_info">
            A janela de 24h está encerrada. Selecione um template aprovado da categoria Marketing para retomar o contato.
          </div>

          <div *ngIf="carregandoTemplatesMarketing" class="text-muted mb-3">
            Carregando templates...
          </div>

          <div *ngIf="!carregandoTemplatesMarketing && templatesMarketing.length == 0" class="text-muted mb-3">
            Nenhum template Marketing aprovado foi localizado na Meta.
          </div>

          <div class="form-group" *ngIf="!carregandoTemplatesMarketing && templatesMarketing.length > 0">
            <label class="mb-1">Template</label>
            <select class="form-control form-control-sm" [(ngModel)]="templateSelecionadoNome" (change)="selecionarTemplateMarketing()" [disabled]="enviandoTemplateMarketing">
              <option value="">Selecione</option>
              <option *ngFor="let template of templatesMarketing" [value]="getTemplateOptionValue(template)">
                {{ template.name }} ({{ template.language }})
              </option>
            </select>
          </div>

          <div *ngIf="templateSelecionado != null">
            <div class="whatsapp_template_variables" *ngIf="templateSelecionado.variables != null && templateSelecionado.variables.length > 0">
              <div class="form-group" *ngFor="let variable of templateSelecionado.variables">
                <label class="mb-1">{{ variable.label || ('Variável ' + variable.index) }}</label>
                <input class="form-control form-control-sm" type="text" [(ngModel)]="templateValores[getTemplateVariableKey(variable)]" [disabled]="enviandoTemplateMarketing" />
              </div>
            </div>

            <div class="whatsapp_template_preview">
              <div class="whatsapp_template_preview_label">Prévia</div>
              <div class="whatsapp_template_preview_text">{{ getPreviewTemplateSelecionado() }}</div>
            </div>
          </div>

          <div class="d-flex flex-wrap justify-content-end mt-3">
            <button class="btn btn-sm btn-outline-secondary mr-2 mb-2" type="button" (click)="fecharPopupTemplateMarketing()" [disabled]="enviandoTemplateMarketing">
              Cancelar
            </button>

            <button class="btn btn-sm whatsapp_link_primary_button mb-2" type="button" (click)="enviarTemplateMarketing()" [disabled]="enviandoTemplateMarketing || templateSelecionado == null">
              {{ enviandoTemplateMarketing ? 'Enviando...' : 'Enviar Template' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupAnalise">
      <div class="whatsapp_analysis_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Analise do Cliente</div>
            <div class="whatsapp_analysis_subtitle" *ngIf="atendimentoSelecionado != null">
              {{ clienteSelecionadoParaAcaoNome || atendimentoSelecionado.client_name_snapshot || getNomeExibicaoAtendimento(atendimentoSelecionado) }}
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharAnaliseCliente()">
            X
          </button>
        </div>

        <iframe class="whatsapp_analysis_frame" [src]="urlAnaliseCliente"></iframe>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupEncaminhar">
      <div class="whatsapp_link_modal whatsapp_link_modal_small">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Encaminhar Atendimento</div>
            <div class="whatsapp_analysis_subtitle" *ngIf="atendimentoSelecionado != null">
              {{ getNomeExibicaoAtendimento(atendimentoSelecionado) }}
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupEncaminhar()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <label class="mb-1">Selecione o vendedor destino</label>

          <select class="form-control form-control-sm" [(ngModel)]="vendedorEncaminhamentoId" [disabled]="carregandoVendedoresEncaminhamento || encaminhandoAtendimento">
            <option [ngValue]="null">{{ carregandoVendedoresEncaminhamento ? 'Carregando vendedores...' : 'Selecione...' }}</option>
            <option *ngFor="let vendedor of vendedoresEncaminhamento" [ngValue]="vendedor.id">{{ vendedor.fullname }}</option>
          </select>

          <div class="whatsapp_forward_notice_preview" *ngIf="vendedorEncaminhamentoId != null">
            O atendimento sera encaminhado e uma mensagem interna sera gravada na conversa.
          </div>

          <div class="d-flex flex-wrap justify-content-end mt-3">
            <button class="btn btn-sm btn-outline-secondary mr-2 mb-2" type="button" (click)="fecharPopupEncaminhar()" [disabled]="encaminhandoAtendimento">
              Cancelar
            </button>

            <button class="btn btn-sm whatsapp_link_primary_button mb-2" type="button" (click)="encaminharAtendimento()" [disabled]="encaminhandoAtendimento || vendedorEncaminhamentoId == null">
              {{ encaminhandoAtendimento ? 'Encaminhando...' : 'Encaminhar Atendimento' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupNovoAtendimento">
      <div class="whatsapp_link_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Novo Atendimento</div>
            <div class="whatsapp_analysis_subtitle">
              Busque um cliente ou informe um WhatsApp para abrir/criar o atendimento.
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupNovoAtendimento()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <div class="whatsapp_new_mode_tabs">
            <button class="btn btn-sm mr-2" type="button" [ngClass]="modoNovoAtendimento == 'cliente' ? 'btn_formulario' : 'btn-outline-secondary'" (click)="alterarModoNovoAtendimento('cliente')">
              Buscar cliente
            </button>
            <button class="btn btn-sm" type="button" [ngClass]="modoNovoAtendimento == 'numero' ? 'btn_formulario' : 'btn-outline-secondary'" (click)="alterarModoNovoAtendimento('numero')">
              Digitar numero
            </button>
          </div>

          <div *ngIf="modoNovoAtendimento == 'cliente'" class="mt-3">
            <label class="mb-1">Buscar por codigo ERP, nome, documento ou fantasia</label>
            <div class="whatsapp_link_search">
              <input class="form-control form-control-sm" type="text" [(ngModel)]="filtroClienteNovoAtendimento" (keydown.enter)="buscarClientesNovoAtendimento()" placeholder="Digite para buscar o cliente" />
              <button class="btn btn-sm btn_formulario" type="button" (click)="buscarClientesNovoAtendimento()" [disabled]="buscandoClientesNovoAtendimento">
                {{ buscandoClientesNovoAtendimento ? 'Buscando...' : 'Buscar' }}
              </button>
            </div>

            <div class="whatsapp_link_results" *ngIf="clientesNovoAtendimento.length > 0">
              <button
                class="whatsapp_client_result"
                type="button"
                *ngFor="let cliente of clientesNovoAtendimento"
                [ngClass]="{ 'whatsapp_client_result_selected': clienteNovoAtendimentoSelecionado != null && clienteNovoAtendimentoSelecionado.id == cliente.id }"
                (click)="selecionarClienteNovoAtendimento(cliente)">
                <div class="whatsapp_client_result_name">{{ cliente.name }}</div>
                <div class="whatsapp_client_result_meta">
                  ERP: {{ cliente.codigo_no_erp_do_cliente || '-' }} |
                  Documento: {{ cliente.client_document || '-' }} |
                  Fantasia: {{ cliente.fantasia || '-' }}
                </div>
                <div class="whatsapp_client_result_meta">
                  WhatsApp: {{ getWhatsappClienteVinculo(cliente) || 'Nao cadastrado' }} |
                  Vendedor interno: {{ cliente.vendedor_interno_nome || 'Nao vinculado' }}
                </div>
              </button>
            </div>

            <div class="whatsapp_empty py-3" *ngIf="!buscandoClientesNovoAtendimento && filtroClienteNovoAtendimento != '' && clientesNovoAtendimento.length == 0">
              Nenhum cliente encontrado para a busca.
            </div>

            <div class="whatsapp_link_selected" *ngIf="clienteNovoAtendimentoSelecionado != null">
              <div class="whatsapp_link_selected_title">Cliente selecionado</div>
              <div>{{ clienteNovoAtendimentoSelecionado.name }}</div>
              <div class="text-muted">
                ERP: {{ clienteNovoAtendimentoSelecionado.codigo_no_erp_do_cliente || '-' }} |
                Documento: {{ clienteNovoAtendimentoSelecionado.client_document || '-' }}
              </div>

              <div class="alert alert-warning py-2 mt-2" *ngIf="getWhatsappClienteVinculo(clienteNovoAtendimentoSelecionado) == ''">
                Cliente sem WhatsApp cadastrado. Informe o DDD e telefone para abrir o atendimento.
              </div>

              <div class="whatsapp_phone_grid mt-2">
                <div>
                  <label class="mb-1">DDD</label>
                  <input class="form-control form-control-sm" type="text" maxlength="2" [(ngModel)]="novoAtendimentoTelefoneDdd" placeholder="19" />
                </div>
                <div>
                  <label class="mb-1">WhatsApp</label>
                  <input class="form-control form-control-sm" type="text" [(ngModel)]="novoAtendimentoTelefone" placeholder="982739199" />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="modoNovoAtendimento == 'numero'" class="mt-3">
            <label class="mb-1">Numero WhatsApp com DDD</label>
            <input class="form-control form-control-sm" type="text" [(ngModel)]="novoAtendimentoNumeroLivre" (keydown.enter)="abrirOuCriarNovoAtendimento()" placeholder="Ex: 19982739199 ou 5519982739199" />
            <div class="text-muted mt-2">
              Se ja existir atendimento para este numero, ele sera aberto. Caso contrario, sera criado em Aberto.
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-sm btn-outline-secondary mr-2" type="button" (click)="fecharPopupNovoAtendimento()" [disabled]="abrindoNovoAtendimento">
              Cancelar
            </button>
            <button class="btn btn-sm whatsapp_link_primary_button" type="button" (click)="abrirOuCriarNovoAtendimento()" [disabled]="abrindoNovoAtendimento">
              {{ abrindoNovoAtendimento ? 'Abrindo...' : 'Abrir atendimento' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupVincularCliente">
      <div class="whatsapp_link_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Vincular Cliente</div>
            <div class="whatsapp_analysis_subtitle" *ngIf="atendimentoSelecionado != null">
              Atendimento: {{ getNomeExibicaoAtendimento(atendimentoSelecionado) }} - {{ atendimentoSelecionado.telefone }}
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupVincularCliente()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <ng-container *ngIf="!exibirFormNovoCliente">
            <label class="mb-1">Buscar por codigo ERP, nome, documento ou fantasia</label>
            <div class="whatsapp_link_search">
              <input class="form-control form-control-sm" type="text" [(ngModel)]="filtroClienteVinculo" (keydown.enter)="buscarClientesVinculo()" placeholder="Digite para buscar o cliente" />
              <button class="btn btn-sm btn_formulario" type="button" (click)="buscarClientesVinculo()" [disabled]="buscandoClientesVinculo">
                {{ buscandoClientesVinculo ? 'Buscando...' : 'Buscar' }}
              </button>
            </div>

            <div class="whatsapp_link_novo_cliente_toggle">
              Não encontrou o cliente?
              <button type="button" class="whatsapp_link_novo_cliente_btn" (click)="abrirFormNovoCliente()">
                <i class="fa fa-plus"></i> Cadastrar novo cliente
              </button>
            </div>

            <div class="whatsapp_link_results" *ngIf="clientesVinculo.length > 0">
              <button
                class="whatsapp_client_result"
                type="button"
                *ngFor="let cliente of clientesVinculo"
                [ngClass]="{ 'whatsapp_client_result_selected': clienteVinculoSelecionado != null && clienteVinculoSelecionado.id == cliente.id }"
                (click)="selecionarClienteVinculo(cliente)">
                <div class="whatsapp_client_result_name">{{ cliente.name }}</div>
                <div class="whatsapp_client_result_meta">
                  ERP: {{ cliente.codigo_no_erp_do_cliente || '-' }} |
                  Documento: {{ cliente.client_document || '-' }} |
                  Fantasia: {{ cliente.fantasia || '-' }}
                </div>
                <div class="whatsapp_client_result_meta">
                  Vendedor interno: {{ cliente.vendedor_interno_nome || 'Nao vinculado' }}
                </div>
              </button>
            </div>

            <div class="whatsapp_empty py-3" *ngIf="!buscandoClientesVinculo && filtroClienteVinculo != '' && clientesVinculo.length == 0">
              Nenhum cliente encontrado para a busca.
            </div>

            <div class="whatsapp_link_selected" *ngIf="clienteVinculoSelecionado != null">
              <div class="whatsapp_link_selected_title">Cliente selecionado</div>
              <div>{{ clienteVinculoSelecionado.name }}</div>
              <div class="text-muted">
                ERP: {{ clienteVinculoSelecionado.codigo_no_erp_do_cliente || '-' }} |
                Documento: {{ clienteVinculoSelecionado.client_document || '-' }}
              </div>

              <button class="btn btn-sm whatsapp_link_primary_button mt-2" type="button" (click)="vincularClienteSelecionado()" [disabled]="vinculandoCliente">
                {{ vinculandoCliente ? 'Vinculando...' : 'Vincular Cliente' }}
              </button>
            </div>
          </ng-container>

          <div class="whatsapp_link_novo_cliente_form" *ngIf="exibirFormNovoCliente && novoCliente != null">
            <div class="whatsapp_link_selected_title">Cadastrar novo cliente</div>

            <label class="w-100 mt-2">
              Razão social / Nome *
              <input class="form-control form-control-sm" type="text" [(ngModel)]="novoCliente.name" placeholder="Nome do cliente" />
            </label>

            <div class="whatsapp_phone_grid mt-2">
              <label class="mb-0">
                DDD
                <input class="form-control form-control-sm" type="text" maxlength="2" [(ngModel)]="novoCliente.fone_whatss_ddd" placeholder="19" />
              </label>
              <label class="mb-0">
                Telefone / WhatsApp
                <input class="form-control form-control-sm" type="text" [(ngModel)]="novoCliente.fone_whatss" placeholder="982739199" />
              </label>
            </div>

            <label class="w-100 mt-2">
              Documento (CNPJ/CPF) - opcional
              <input class="form-control form-control-sm" type="text" [(ngModel)]="novoCliente.client_document" placeholder="Opcional" />
            </label>

            <div class="mt-2">
              <button class="btn btn-sm whatsapp_link_primary_button mr-2" type="button" (click)="cadastrarNovoClienteEVincular()" [disabled]="cadastrandoCliente">
                {{ cadastrandoCliente ? 'Cadastrando...' : 'Cadastrar e Vincular' }}
              </button>
              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancelarFormNovoCliente()" [disabled]="cadastrandoCliente">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupClientesVinculados">
      <div class="whatsapp_link_modal">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Clientes Vinculados</div>
            <div class="whatsapp_analysis_subtitle" *ngIf="atendimentoSelecionado != null">
              Principal: {{ atendimentoSelecionado.client_name_snapshot || getNomeExibicaoAtendimento(atendimentoSelecionado) }}
            </div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupClientesVinculados()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <div class="whatsapp_empty py-2" *ngIf="carregandoClientesVinculados">
            Carregando...
          </div>

          <div class="whatsapp_empty py-2" *ngIf="!carregandoClientesVinculados && clientesVinculados.length == 0">
            Nenhum cliente vinculado ainda.
          </div>

          <div class="whatsapp_link_results" *ngIf="!carregandoClientesVinculados && clientesVinculados.length > 0">
            <div class="whatsapp_client_result whatsapp_client_result_vinculado" *ngFor="let vinculo of clientesVinculados">
              <div>
                <div class="whatsapp_client_result_name">{{ vinculo.name }}</div>
                <div class="whatsapp_client_result_meta">
                  ERP: {{ vinculo.codigo_no_erp_do_cliente || '-' }} |
                  Documento: {{ vinculo.client_document || '-' }} |
                  Fantasia: {{ vinculo.fantasia || '-' }}
                </div>
              </div>

              <button
                class="whatsapp_meta_chip_action whatsapp_client_result_remover"
                type="button"
                [disabled]="desvinculandoClienteId == vinculo.vinculo_id"
                title="Remover vínculo"
                (click)="removerClienteVinculado(vinculo)">
                <i class="fa" [ngClass]="desvinculandoClienteId == vinculo.vinculo_id ? 'fa-spinner fa-spin' : 'fa-times'"></i>
              </button>
            </div>
          </div>

          <hr>

          <label class="mb-1">Vincular outro cliente - buscar por codigo ERP, nome, documento ou fantasia</label>
          <div class="whatsapp_link_search">
            <input class="form-control form-control-sm" type="text" [(ngModel)]="filtroClienteParaVincular" (keydown.enter)="buscarClientesParaVincular()" placeholder="Digite para buscar o cliente" />
            <button class="btn btn-sm btn_formulario" type="button" (click)="buscarClientesParaVincular()" [disabled]="buscandoClientesParaVincular">
              {{ buscandoClientesParaVincular ? 'Buscando...' : 'Buscar' }}
            </button>
          </div>

          <div class="whatsapp_link_results" *ngIf="clientesParaVincular.length > 0">
            <button
              class="whatsapp_client_result"
              type="button"
              *ngFor="let cliente of clientesParaVincular"
              [disabled]="vinculandoClienteAdicional"
              (click)="vincularClienteAdicional(cliente)">
              <div class="whatsapp_client_result_name">{{ cliente.name }}</div>
              <div class="whatsapp_client_result_meta">
                ERP: {{ cliente.codigo_no_erp_do_cliente || '-' }} |
                Documento: {{ cliente.client_document || '-' }} |
                Fantasia: {{ cliente.fantasia || '-' }}
              </div>
            </button>
          </div>

          <div class="whatsapp_empty py-3" *ngIf="!buscandoClientesParaVincular && filtroClienteParaVincular != '' && clientesParaVincular.length == 0">
            Nenhum cliente encontrado para a busca.
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupSelecionarClienteAcao">
      <div class="whatsapp_link_modal whatsapp_link_modal_small">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Selecionar Cliente</div>
            <div class="whatsapp_analysis_subtitle">Este atendimento tem mais de um cliente vinculado. Escolha qual deseja usar.</div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupSelecionarClienteAcao()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body">
          <div class="whatsapp_link_results" *ngIf="atendimentoSelecionado != null">
            <button
              class="whatsapp_client_result"
              type="button"
              (click)="selecionarClienteParaAcao(atendimentoSelecionado.client_id, atendimentoSelecionado.client_codigo_erp_snapshot, atendimentoSelecionado.client_name_snapshot)">
              <div class="whatsapp_client_result_name">{{ atendimentoSelecionado.client_name_snapshot }} <span class="whatsapp_client_result_principal">Principal</span></div>
              <div class="whatsapp_client_result_meta">
                ERP: {{ atendimentoSelecionado.client_codigo_erp_snapshot || '-' }}
              </div>
            </button>

            <button
              class="whatsapp_client_result"
              type="button"
              *ngFor="let vinculo of clientesVinculados"
              (click)="selecionarClienteParaAcao(vinculo.client_id, vinculo.codigo_no_erp_do_cliente, vinculo.name)">
              <div class="whatsapp_client_result_name">{{ vinculo.name }}</div>
              <div class="whatsapp_client_result_meta">
                ERP: {{ vinculo.codigo_no_erp_do_cliente || '-' }} |
                Documento: {{ vinculo.client_document || '-' }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="whatsapp_analysis_overlay" *ngIf="exibirPopupVendedorCliente">
      <div class="whatsapp_link_modal whatsapp_link_modal_small">
        <div class="whatsapp_analysis_header">
          <div>
            <div class="whatsapp_analysis_title">Destino do Atendimento</div>
            <div class="whatsapp_analysis_subtitle">Cliente vinculado com sucesso.</div>
          </div>

          <button class="whatsapp_analysis_close" type="button" (click)="fecharPopupVendedorCliente()">
            X
          </button>
        </div>

        <div class="whatsapp_link_body" *ngIf="clienteVinculoSelecionado != null">
          <div class="whatsapp_link_selected mb-3">
            <div class="whatsapp_link_selected_title">Cliente</div>
            <div>{{ clienteVinculoSelecionado.name }}</div>
            <div class="text-muted">ERP: {{ clienteVinculoSelecionado.codigo_no_erp_do_cliente || '-' }}</div>
          </div>

          <div class="whatsapp_link_selected mb-3">
            <div class="whatsapp_link_selected_title">Vendedor interno vinculado ao cliente</div>
            <div>{{ clienteVinculoSelecionado.vendedor_interno_nome || 'Nenhum vendedor interno vinculado' }}</div>
          </div>

          <div class="d-flex flex-wrap justify-content-end">
            <button class="btn btn-sm btn-outline-primary mr-2 mb-2" type="button" (click)="vincularClienteAoVendedorInterno()" [disabled]="vinculandoCliente || clienteVinculoSelecionado.vendedor_interno_id == null">
              Vincular cliente ao vendedor interno exibido
            </button>

            <button class="btn btn-sm btn_formulario mb-2" type="button" (click)="capturarAtendimentoAposVinculo()" [disabled]="vinculandoCliente">
              Capturar atendimento para meu seller
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="abaAtiva == 'kanban'" class="kanban_wrapper">
      <div class="kanban_column" *ngFor="let etapa of kanban.etapas">
        <div class="kanban_column_header" [ngStyle]="{ 'border-top-color': etapa.cor_hex || '#00679a' }">
          <div class="kanban_column_type" [ngClass]="getClasseTipoEtapaKanban(etapa)">
            {{ getTipoEtapaKanban(etapa) }}
          </div>
          <div class="kanban_column_title">{{ etapa.nome }}</div>
          <div class="kanban_column_count">{{ getAtendimentosPorEtapa(etapa.id).length }} item(ns)</div>
        </div>

        <div class="kanban_cards" dndEffectAllowed="move" (dndDrop)="onDrop($event, etapa, getAtendimentosPorEtapa(etapa.id))" dndDropzone>
          <div class="kanban_placeholder" dndPlaceholderRef></div>

          <div
            class="kanban_card"
            *ngFor="let atendimento of getAtendimentosPorEtapa(etapa.id)"
            [dndDraggable]="atendimento"
            [dndEffectAllowed]="'move'"
            [dndDisableIf]="!podeMoverCard(atendimento)"
            (dndStart)="onDragStart($event, atendimento)"
            (dndMoved)="onDragged(atendimento, getAtendimentosPorEtapa(etapa.id), 'move')"
            (dndCopied)="onDragged(atendimento, getAtendimentosPorEtapa(etapa.id), 'copy')"
            (dndLinked)="onDragged(atendimento, getAtendimentosPorEtapa(etapa.id), 'link')"
            (dndCanceled)="onDragged(atendimento, getAtendimentosPorEtapa(etapa.id), 'none')"
            (dndEnd)="onDragEnd($event)"
            [ngClass]="{ 'kanban_card_dragging': atendimentoArrastandoId == atendimento.id }">
            <div class="d-flex justify-content-between align-items-start">
              <div class="kanban_card_title">{{ getNomeExibicaoAtendimento(atendimento) }}</div>
              <span class="badge badge-pill badge-light" *ngIf="atendimento.qtde_mensagens_nao_lidas > 0">
                {{ atendimento.qtde_mensagens_nao_lidas }}
              </span>
            </div>

            <div class="kanban_card_phone">{{ atendimento.telefone }}</div>

            <div class="kanban_card_client" *ngIf="atendimento.client_name_snapshot">
              Cliente: {{ atendimento.client_name_snapshot }}
            </div>

            <div class="kanban_card_client" *ngIf="atendimento.client_codigo_erp_snapshot">
              ERP: {{ atendimento.client_codigo_erp_snapshot }}
            </div>

            <div class="kanban_card_preview">{{ getPreviewAtendimentoLimitado(atendimento) }}</div>

            <div class="mt-2">
              <span class="badge badge-pill mr-1" [ngClass]="getClasseTempo(atendimento)">
                {{ getRotuloTempo(atendimento) }}
              </span>
              <span class="badge badge-pill badge-warning" *ngIf="atendimento.seller_id_atual == null">
                Livre
              </span>
              <span class="badge badge-pill badge-info" *ngIf="atendimento.seller_id_atual == sellerId">
                Meu
              </span>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
              <small class="text-muted">{{ atendimento.dt_ultima_mensagem | date:'dd/MM HH:mm' }}</small>

              <div class="d-flex">
                <button class="btn btn-outline-secondary btn-sm mr-2" type="button" *ngIf="isAtendimentoCapturavel(atendimento)" (click)="capturarAtendimentoCard(atendimento)">
                  Capturar
                </button>
                <button class="btn btn-outline-primary btn-sm" type="button" (click)="abrirAtendimentoNoInbox(atendimento)">
                  Abrir
                </button>
              </div>
            </div>
          </div>

          <div class="kanban_empty" *ngIf="getAtendimentosPorEtapa(etapa.id).length == 0">
            Nenhum atendimento nesta etapa.
          </div>
        </div>
      </div>
    </div>
  </div>
  </ng-container>

  <ng-template #whatsappOficialDisabled>
    <section class="whatsapp-disabled-hero">
      <div class="whatsapp-disabled-copy">
        <span class="whatsapp-disabled-badge">Novo modulo</span>
        <h1>WhatsApp Oficial Napis</h1>
        <p class="whatsapp-disabled-lead">
          Atendimento em tempo real integrado a API oficial da Meta, com conversas, funil, midias, templates e historico comercial em uma unica tela.
        </p>
        <div class="whatsapp-disabled-alert">
          Esta funcao ainda nao esta habilitada para o seu usuario. Entre em contato com o suporte para agendar uma apresentacao.
        </div>
      </div>

      <div class="whatsapp-preview-shell" aria-hidden="true">
        <div class="whatsapp-preview-sidebar">
          <strong>Conversas</strong>
          <div class="whatsapp-preview-contact active">
            <span>Cliente Sakamoto</span>
            <small>Pedido de cotacao...</small>
          </div>
          <div class="whatsapp-preview-contact">
            <span>Auto Pecas Lima</span>
            <small>Documento recebido</small>
          </div>
        </div>
        <div class="whatsapp-preview-chat">
          <div class="whatsapp-preview-chip">Atendimento</div>
          <div class="whatsapp-preview-bubble inbound">Ola, tem promocao hoje?</div>
          <div class="whatsapp-preview-bubble outbound">Temos uma condicao especial. Posso te enviar?</div>
          <div class="whatsapp-preview-input">Digite uma mensagem...</div>
        </div>
        <div class="whatsapp-preview-kanban">
          <span>Aberto</span>
          <span>Atendimento</span>
          <span>Ganho</span>
        </div>
      </div>
    </section>

    <section class="whatsapp-feature-grid">
      <article>
        <span>01</span>
        <h3>Conversas em tempo real</h3>
        <p>Receba e envie mensagens, imagens, documentos, audios e emojis sem recarregar a tela.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Atendimento com funil</h3>
        <p>Capture conversas, encaminhe para vendedores, acompanhe etapas e finalize como ganho ou perda.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Cliente vinculado</h3>
        <p>Identifique cliente, ERP e vendedor responsavel, abrindo analise e novo pedido direto do atendimento.</p>
      </article>
      <article>
        <span>04</span>
        <h3>API oficial Meta</h3>
        <p>Use templates aprovados, status de leitura e controle da janela de 24 horas do WhatsApp oficial.</p>
      </article>
    </section>
  </ng-template>
</div>

<!-- Popup: Histórico de pagamentos gerados pela IA (master/diretor) -->
<div class="whatsapp_pg_overlay" *ngIf="exibirPopupPagamentos" (click)="fecharPopupPagamentos()">
  <div class="whatsapp_pg_popup" (click)="$event.stopPropagation()">
    <div class="whatsapp_pg_header">
      <div>
        <div class="whatsapp_pg_titulo"><i class="fa fa-credit-card"></i> Pagamentos gerados pela IA</div>
        <div class="whatsapp_pg_subtitulo">Últimas {{ iaPagamentos.cobrancas.length }} cobranças · checkout Mercado Pago</div>
      </div>

      <button class="whatsapp_pg_fechar" type="button" (click)="fecharPopupPagamentos()" title="Fechar">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="whatsapp_pg_resumo" *ngIf="!carregandoPagamentos">
      <div class="whatsapp_pg_resumo_item whatsapp_pg_resumo_pago">
        <b>{{ getTotalPagamentosPagos() | currency:'BRL' }}</b>
        <small>{{ getQtdePagamentosPagos() }} pagamento(s) confirmado(s)</small>
      </div>
      <div class="whatsapp_pg_resumo_item">
        <b>{{ getQtdePagamentosAguardando() }}</b>
        <small>aguardando pagamento</small>
      </div>
    </div>

    <div class="whatsapp_pg_body">
      <div class="whatsapp_pg_carregando" *ngIf="carregandoPagamentos">
        <i class="fa fa-spinner fa-spin"></i> Carregando pagamentos...
      </div>

      <div class="whatsapp_pg_vazio" *ngIf="!carregandoPagamentos && iaPagamentos.cobrancas.length == 0">
        Nenhuma cobrança gerada ainda. Quando a IA enviar links de pagamento nas conversas, elas aparecem aqui.
      </div>

      <div class="table-responsive" *ngIf="!carregandoPagamentos && iaPagamentos.cobrancas.length > 0">
        <table class="table table-sm table-hover whatsapp_pg_tabela">
          <thead>
            <tr>
              <th>Data</th>
              <th>Contato</th>
              <th>Plano</th>
              <th class="text-right">Valor</th>
              <th class="text-center">Status</th>
              <th>Pagamento</th>
              <th>Pago em</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cobranca of iaPagamentos.cobrancas">
              <td>{{ cobranca.created_at | date:'dd/MM/yy HH:mm' }}</td>
              <td>
                <b>{{ cobranca.contato_nome || cobranca.telefone }}</b>
                <small class="d-block text-muted" *ngIf="cobranca.contato_nome">{{ cobranca.telefone }}</small>
              </td>
              <td>{{ cobranca.plano_nome || '—' }}</td>
              <td class="text-right"><b>{{ cobranca.valor | currency:'BRL' }}</b></td>
              <td class="text-center">
                <span class="badge badge-pill" [ngClass]="getClasseStatusPagamento(cobranca)">{{ getRotuloStatusPagamento(cobranca) }}</span>
              </td>
              <td>{{ getMetodoPagamento(cobranca) }}</td>
              <td>{{ cobranca.dt_pagamento != null ? (cobranca.dt_pagamento | date:'dd/MM/yy HH:mm') : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Popup: Gestao de templates de mensagem (is_master/is_diretor) -->
<div class="whatsapp_pg_overlay" *ngIf="exibirPopupTemplatesGestao" (click)="fecharPopupTemplatesGestao()">
  <div class="whatsapp_pg_popup whatsapp_tpl_popup" (click)="$event.stopPropagation()">
    <div class="whatsapp_pg_header">
      <div>
        <div class="whatsapp_pg_titulo"><i class="fa fa-file-text-o"></i> Templates de mensagem</div>
        <div class="whatsapp_pg_subtitulo" *ngIf="templateEdicao == null">Mensagens prontas para uso rapido no atendimento via instancia.</div>
        <div class="whatsapp_pg_subtitulo" *ngIf="templateEdicao != null">{{ templateEdicao.id > 0 ? 'Editando template' : 'Novo template' }}</div>
      </div>

      <button class="whatsapp_pg_fechar" type="button" (click)="fecharPopupTemplatesGestao()" title="Fechar">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="whatsapp_pg_body whatsapp_tpl_body">
      <div class="whatsapp_pg_carregando" *ngIf="carregandoTemplatesGestao">
        <i class="fa fa-spinner fa-spin"></i> Carregando templates...
      </div>

      <!-- Lista de templates -->
      <ng-container *ngIf="!carregandoTemplatesGestao && templateEdicao == null">
        <div class="whatsapp_tpl_lista_toolbar">
          <button class="btn btn-sm whatsapp_btn_novo" type="button" (click)="novoTemplateMensagem()">
            <i class="fa fa-plus"></i> Novo template
          </button>
        </div>

        <div class="whatsapp_pg_vazio" *ngIf="templatesGestao.length == 0">
          Nenhum template cadastrado ainda.
        </div>

        <div class="whatsapp_tpl_item" *ngFor="let template of templatesGestao">
          <div class="whatsapp_tpl_item_info">
            <b>{{ template.nome }}</b>
            <small class="text-muted d-block" *ngIf="template.descricao">{{ template.descricao }}</small>
            <small class="text-muted d-block">{{ template.itens.length }} bloco(s) · {{ template.seller_ids.length }} vendedor(es) liberado(s)</small>
          </div>

          <div class="whatsapp_tpl_item_acoes">
            <span class="badge badge-pill" [ngClass]="template.ativo ? 'badge-success' : 'badge-secondary'">
              {{ template.ativo ? 'Ativo' : 'Inativo' }}
            </span>

            <button class="whatsapp_icon_btn" type="button" title="Editar" (click)="editarTemplateMensagem(template)">
              <i class="fa fa-pencil"></i>
            </button>

            <button class="whatsapp_icon_btn" type="button" [title]="template.ativo ? 'Desativar' : 'Ativar'" (click)="alternarAtivoTemplateMensagem(template)">
              <i class="fa" [ngClass]="template.ativo ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Editor de template -->
      <div class="whatsapp_tpl_editor" *ngIf="!carregandoTemplatesGestao && templateEdicao != null">
        <div class="form-group">
          <label>Nome do template</label>
          <input type="text" class="form-control form-control-sm" maxlength="150" [(ngModel)]="templateEdicao.nome" placeholder="Ex: Boas-vindas" />
        </div>

        <div class="form-group">
          <label>Descricao (opcional)</label>
          <input type="text" class="form-control form-control-sm" maxlength="300" [(ngModel)]="templateEdicao.descricao" placeholder="Uso interno, para identificar o template" />
        </div>

        <label>Conteudo</label>
        <div class="whatsapp_tpl_itens">
          <div class="whatsapp_tpl_item_editor" *ngFor="let item of templateEdicao.itens; let i = index">
            <div class="whatsapp_tpl_item_editor_header">
              <span class="badge badge-pill badge-info">
                <ng-container [ngSwitch]="item.tipo">
                  <span *ngSwitchCase="'TEXTO'">Texto</span>
                  <span *ngSwitchCase="'IMAGEM'">Imagem</span>
                  <span *ngSwitchCase="'ARQUIVO'">Arquivo</span>
                  <span *ngSwitchCase="'LINK'">Link</span>
                  <span *ngSwitchCase="'LISTA_OPCOES'">Lista de opcoes</span>
                </ng-container>
              </span>

              <div class="whatsapp_tpl_item_editor_acoes">
                <button class="whatsapp_icon_btn" type="button" title="Mover para cima" [disabled]="i == 0" (click)="moverItemTemplate(i, -1)">
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button class="whatsapp_icon_btn" type="button" title="Mover para baixo" [disabled]="i == templateEdicao.itens.length - 1" (click)="moverItemTemplate(i, 1)">
                  <i class="fa fa-arrow-down"></i>
                </button>
                <button class="whatsapp_icon_btn" type="button" title="Remover bloco" (click)="removerItemTemplate(i)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="form-group mb-2" *ngIf="item.tipo == 'TEXTO' || item.tipo == 'LISTA_OPCOES'">
              <textarea class="form-control form-control-sm" rows="2" maxlength="4000" [(ngModel)]="item.conteudo_texto" placeholder="Texto da mensagem"></textarea>
            </div>

            <ng-container *ngIf="item.tipo == 'IMAGEM' || item.tipo == 'ARQUIVO'">
              <div class="whatsapp_tpl_arquivo_box">
                <button class="btn btn-sm btn-outline-secondary" type="button" (click)="arquivoTemplateInput.click()" [disabled]="enviandoArquivoTemplateItem == i">
                  <i class="fa fa-spinner fa-spin" *ngIf="enviandoArquivoTemplateItem == i"></i>
                  <i class="fa fa-upload" *ngIf="enviandoArquivoTemplateItem != i"></i>
                  {{ item.arquivo_url ? 'Trocar arquivo' : 'Selecionar arquivo' }}
                </button>
                <input #arquivoTemplateInput type="file" hidden (change)="selecionarArquivoItemTemplate($event, item, i)" [accept]="item.tipo == 'IMAGEM' ? 'image/jpeg,image/png,image/webp' : undefined" />
                <small class="d-block text-muted mt-1" *ngIf="item.arquivo_nome">{{ item.arquivo_nome }}</small>
              </div>

              <div class="form-group mb-2 mt-2" *ngIf="item.tipo == 'IMAGEM'">
                <input type="text" class="form-control form-control-sm" maxlength="1024" [(ngModel)]="item.conteudo_texto" placeholder="Legenda (opcional)" />
              </div>
            </ng-container>

            <ng-container *ngIf="item.tipo == 'LINK'">
              <div class="form-group mb-2">
                <input type="text" class="form-control form-control-sm" maxlength="600" [(ngModel)]="item.link_url" placeholder="https://..." />
              </div>
              <div class="form-group mb-2">
                <input type="text" class="form-control form-control-sm" maxlength="100" [(ngModel)]="item.link_texto" placeholder="Texto do link (ex: Acessar link de pagamento)" />
              </div>
              <div class="form-group mb-2">
                <input type="text" class="form-control form-control-sm" maxlength="1024" [(ngModel)]="item.conteudo_texto" placeholder="Mensagem que acompanha o link (opcional)" />
              </div>
            </ng-container>

            <div class="whatsapp_tpl_opcoes" *ngIf="item.tipo == 'LISTA_OPCOES'">
              <div class="whatsapp_tpl_opcao_row" *ngFor="let opcao of item.opcoes; let oi = index">
                <input type="text" class="form-control form-control-sm" maxlength="100" [(ngModel)]="opcao.titulo" placeholder="Titulo da opcao" />
                <input type="text" class="form-control form-control-sm" maxlength="200" [(ngModel)]="opcao.descricao" placeholder="Descricao (opcional)" />
                <button class="whatsapp_icon_btn" type="button" title="Remover opcao" [disabled]="item.opcoes.length <= 1" (click)="removerOpcaoItem(item, oi)">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarOpcaoItem(item)">
                <i class="fa fa-plus"></i> Adicionar opcao
              </button>

              <div class="form-group mb-0 mt-2">
                <input type="text" class="form-control form-control-sm" maxlength="50" [(ngModel)]="item.list_button" placeholder="Texto do botao da lista (ex: Ver opcoes)" />
              </div>
            </div>
          </div>
        </div>

        <div class="whatsapp_tpl_add_bar">
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarItemTemplate('TEXTO')"><i class="fa fa-align-left"></i> Texto</button>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarItemTemplate('IMAGEM')"><i class="fa fa-image"></i> Imagem</button>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarItemTemplate('ARQUIVO')"><i class="fa fa-paperclip"></i> Arquivo</button>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarItemTemplate('LINK')"><i class="fa fa-link"></i> Link</button>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="adicionarItemTemplate('LISTA_OPCOES')"><i class="fa fa-list"></i> Lista de opcoes</button>
        </div>

        <label class="mt-3">Vendedores com acesso a este template</label>
        <div class="whatsapp_tpl_sellers">
          <div class="whatsapp_pg_vazio" *ngIf="sellersAptosTemplate.length == 0">
            Nenhum vendedor apto (habilite o WhatsApp por instancia no cadastro do vendedor).
          </div>

          <label class="whatsapp_tpl_seller_check" *ngFor="let seller of sellersAptosTemplate">
            <input type="checkbox" [checked]="isSellerSelecionadoTemplate(seller.id)" (change)="alternarSellerTemplate(seller.id)" />
            {{ seller.fullname }}
          </label>
        </div>

        <div class="whatsapp_tpl_editor_footer">
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancelarEdicaoTemplate()" [disabled]="salvandoTemplate">
            Cancelar
          </button>
          <button class="btn btn-sm whatsapp_btn_novo" type="button" (click)="salvarTemplateMensagem()" [disabled]="salvandoTemplate">
            <i class="fa fa-spinner fa-spin" *ngIf="salvandoTemplate"></i>
            Salvar template
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Popup: Selecionar e enviar template de mensagem na conversa -->
<div class="whatsapp_pg_overlay" *ngIf="exibirPopupTemplatesSelecionar" (click)="fecharPopupTemplatesSelecionar()">
  <div class="whatsapp_pg_popup whatsapp_tpl_popup" (click)="$event.stopPropagation()">
    <div class="whatsapp_pg_header">
      <div>
        <div class="whatsapp_pg_titulo"><i class="fa fa-file-text-o"></i> Usar template</div>
        <div class="whatsapp_pg_subtitulo">Selecione um template para enviar nesta conversa.</div>
      </div>

      <button class="whatsapp_pg_fechar" type="button" (click)="fecharPopupTemplatesSelecionar()" title="Fechar">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="whatsapp_pg_body whatsapp_tpl_selecionar_body">
      <div class="whatsapp_pg_carregando" *ngIf="carregandoTemplatesDisponiveis">
        <i class="fa fa-spinner fa-spin"></i> Carregando templates...
      </div>

      <ng-container *ngIf="!carregandoTemplatesDisponiveis">
        <div class="whatsapp_pg_vazio" *ngIf="templatesDisponiveis.length == 0">
          Nenhum template disponivel para o seu usuario.
        </div>

        <div class="whatsapp_tpl_selecionar_lista">
          <button
            type="button"
            class="whatsapp_tpl_selecionar_item"
            *ngFor="let template of templatesDisponiveis"
            [class.whatsapp_tpl_selecionar_item_ativo]="templateSelecionadoPreview != null && templateSelecionadoPreview.id == template.id"
            (click)="previewTemplateMensagem(template)">
            <b>{{ template.nome }}</b>
            <small class="d-block text-muted" *ngIf="template.descricao">{{ template.descricao }}</small>
          </button>
        </div>

        <div class="whatsapp_tpl_preview" *ngIf="templateSelecionadoPreview != null">
          <div class="whatsapp_tpl_preview_titulo">Previa da mensagem</div>

          <div class="whatsapp_tpl_preview_item" *ngFor="let item of templateSelecionadoPreview.itens">
            <div class="whatsapp_tpl_preview_bubble" *ngIf="item.tipo == 'TEXTO'">
              {{ item.conteudo_texto }}
            </div>

            <div class="whatsapp_tpl_preview_bubble" *ngIf="item.tipo == 'IMAGEM'">
              <img [src]="item.arquivo_url" class="whatsapp_tpl_preview_img" />
              <div *ngIf="item.conteudo_texto">{{ item.conteudo_texto }}</div>
            </div>

            <div class="whatsapp_tpl_preview_bubble" *ngIf="item.tipo == 'ARQUIVO'">
              <i class="fa fa-file-o"></i> {{ item.arquivo_nome }}
            </div>

            <div class="whatsapp_tpl_preview_bubble" *ngIf="item.tipo == 'LINK'">
              <div *ngIf="item.conteudo_texto">{{ item.conteudo_texto }}</div>
              <a href="javascript:void(0)">{{ item.link_texto || 'Acessar link' }}</a>
            </div>

            <div class="whatsapp_tpl_preview_bubble" *ngIf="item.tipo == 'LISTA_OPCOES'">
              <div>{{ item.conteudo_texto }}</div>
              <div class="whatsapp_tpl_preview_opcoes">
                <span class="badge badge-light" *ngFor="let opcao of item.opcoes">{{ opcao.titulo }}</span>
              </div>
            </div>
          </div>

          <div class="whatsapp_tpl_preview_footer">
            <button class="btn btn-sm whatsapp_btn_novo" type="button" (click)="enviarTemplateSelecionado()" [disabled]="enviandoTemplateSelecionado">
              <i class="fa fa-spinner fa-spin" *ngIf="enviandoTemplateSelecionado"></i>
              Enviar template
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #enviarContatoModal>
  <div class="modal-header"><h5 class="modal-title">Enviar contato</h5><button type="button" class="close" [disabled]="enviandoContato" (click)="fecharEnvioContato()" aria-label="Fechar">×</button></div>
  <div class="modal-body">
    <p>Para: <strong>{{ contatoDestinoNome }}</strong></p>
    <ng-container *ngIf="!confirmandoContato; else confirmarContatoEnvio">
      <input class="form-control mb-3" placeholder="Pesquisar nome ou número" aria-label="Pesquisar contato" [(ngModel)]="filtroContatoEnvio" />
      <p *ngIf="carregandoContatos">Carregando agenda...</p>
      <div style="max-height: 360px; overflow-y: auto;">
        <label *ngFor="let contato of contatosEnvioFiltrados" class="d-flex align-items-center border-bottom p-2" style="cursor:pointer">
          <input type="radio" name="contatoEnvio" class="mr-3" [checked]="contatoEnvioSelecionado === contato" (change)="contatoEnvioSelecionado = contato" />
          <span><strong>{{ contato.name }}</strong><small class="d-block">{{ contato.phone }}</small></span>
        </label>
      </div>
      <p *ngIf="!carregandoContatos && !contatosEnvioFiltrados.length">Nenhum contato encontrado.</p>
      <small>Selecione um contato por envio. Use a busca para localizar na agenda.</small>
    </ng-container>
    <ng-template #confirmarContatoEnvio>
      <p>Deseja enviar este contato?</p>
      <div class="border rounded p-3"><strong>{{ contatoEnvioSelecionado?.name }}</strong><div>{{ contatoEnvioSelecionado?.phone }}</div></div>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" [disabled]="enviandoContato" (click)="confirmandoContato ? confirmandoContato = false : fecharEnvioContato()">{{ confirmandoContato ? 'Voltar' : 'Cancelar' }}</button>
    <button class="btn btn-success" type="button" *ngIf="!confirmandoContato" [disabled]="!contatoEnvioSelecionado || carregandoContatos" (click)="confirmandoContato = true">Continuar</button>
    <button class="btn btn-success" type="button" *ngIf="confirmandoContato" [disabled]="enviandoContato" (click)="confirmarEnvioContato()">{{ enviandoContato ? 'Enviando...' : 'Enviar contato' }}</button>
  </div>
</ng-template>
